//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAnnouncementServiceProxy {
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(userId: number | null | undefined, tenantId: number | null | undefined): Observable<AnnouncementDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AnnouncementServiceProxy implements IAnnouncementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(userId: number | null | undefined, tenantId: number | null | undefined): Observable<AnnouncementDto[]> {
        let url_ = this.baseUrl + "/api/announcement/get?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnouncementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnouncementDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AnnouncementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnouncementDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnouncementDto[]>(null as any);
    }
}

export interface IArchiveServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    archive(body: RequestArchiveInputDto | undefined): Observable<void>;
    /**
     * @return Success
     */
    getArgs(): Observable<ArchiveArgsDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ArchiveServiceProxy implements IArchiveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    archive(body: RequestArchiveInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/archive/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getArgs(): Observable<ArchiveArgsDto> {
        let url_ = this.baseUrl + "/api/archive/get-args";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArgs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArgs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchiveArgsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchiveArgsDto>;
        }));
    }

    protected processGetArgs(response: HttpResponseBase): Observable<ArchiveArgsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchiveArgsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArchiveArgsDto>(null as any);
    }
}

export interface IArtifactTaskServiceProxy {
    /**
     * @param body_TaskState (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_TaskState: ArtifactTaskState | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<TaskListDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    markAsCompleted(body: TenancyRequestDtoOfEntityDto | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_TaskState (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    count(body_TaskState: ArtifactTaskState | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class ArtifactTaskServiceProxy implements IArtifactTaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body_TaskState (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_TaskState: ArtifactTaskState | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<TaskListDto[]> {
        let url_ = this.baseUrl + "/api/artifact-task/get?";
        if (body_TaskState === null)
            throw new Error("The parameter 'body_TaskState' cannot be null.");
        else if (body_TaskState !== undefined)
            url_ += "Body.TaskState=" + encodeURIComponent("" + body_TaskState) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaskListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaskListDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TaskListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaskListDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskListDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAsCompleted(body: TenancyRequestDtoOfEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/artifact-task/mark-as-completed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsCompleted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/artifact-task/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_TaskState (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    count(body_TaskState: ArtifactTaskState | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/artifact-task/get/count?";
        if (body_TaskState === null)
            throw new Error("The parameter 'body_TaskState' cannot be null.");
        else if (body_TaskState !== undefined)
            url_ += "Body.TaskState=" + encodeURIComponent("" + body_TaskState) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

export interface IAuditLogServiceProxy {
    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    get(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto>;
    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    toExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AuditLogServiceProxy implements IAuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    get(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/audit-log/get?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResultDtoOfAuditLogListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuditLogListDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    toExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/audit-log/get/to-excel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

export interface IAuthorizationServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    requestVerificationCode(body: TenancyRequestDto | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthorizationServiceProxy implements IAuthorizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestVerificationCode(body: TenancyRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/authorization/request-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestVerificationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestVerificationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestVerificationCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ICachingServiceProxy {
    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void>;
    /**
     * @return Success
     */
    clearAllCaches(): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class CachingServiceProxy implements ICachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListResultDtoOfCacheDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCacheDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ICompaniesServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataManagerRequest | undefined): Observable<void>;
    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CompanyDto>;
    /**
     * @param id (optional) 
     * @return Success
     */
    featuresGet(id: number | undefined): Observable<GetTenantFeaturesEditOutput>;
    /**
     * @param companyId (optional) 
     * @return Success
     */
    employeeCardOptionsGet(companyId: number | undefined): Observable<CompanyEmployeeCardOptionsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    featuresPut(body: UpdateTenantFeaturesInput | undefined): Observable<void>;
    /**
     * @param companyId (optional) 
     * @param body (optional) 
     * @return Success
     */
    employeeCardOptionsPut(companyId: number | undefined, body: CompanyEmployeeCardOptionsDto | undefined): Observable<CompanyEmployeeCardOptionsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCompanyInput | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCompanyInput | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class CompaniesServiceProxy implements ICompaniesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataManagerRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/companies/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/companies/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    featuresGet(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/companies/get/features?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeaturesGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeaturesGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processFeaturesGet(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTenantFeaturesEditOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantFeaturesEditOutput>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    employeeCardOptionsGet(companyId: number | undefined): Observable<CompanyEmployeeCardOptionsDto> {
        let url_ = this.baseUrl + "/api/companies/get/employee-card-options?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeeCardOptionsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeeCardOptionsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyEmployeeCardOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyEmployeeCardOptionsDto>;
        }));
    }

    protected processEmployeeCardOptionsGet(response: HttpResponseBase): Observable<CompanyEmployeeCardOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyEmployeeCardOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyEmployeeCardOptionsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    featuresPut(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/companies/update/features";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeaturesPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeaturesPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFeaturesPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param body (optional) 
     * @return Success
     */
    employeeCardOptionsPut(companyId: number | undefined, body: CompanyEmployeeCardOptionsDto | undefined): Observable<CompanyEmployeeCardOptionsDto> {
        let url_ = this.baseUrl + "/api/companies/update/employee-card-options?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeeCardOptionsPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeeCardOptionsPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyEmployeeCardOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyEmployeeCardOptionsDto>;
        }));
    }

    protected processEmployeeCardOptionsPut(response: HttpResponseBase): Observable<CompanyEmployeeCardOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyEmployeeCardOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyEmployeeCardOptionsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCompanyInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/companies/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCompanyInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/companies/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IDocumentTagOrganizationUnitServiceProxy {
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getList(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagOrganizationUnitDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateDocumentTagOrganizationUnitDto | undefined): Observable<DocumentTagOrganizationUnitDto>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTagOrganizationUnitGet(id: number, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagOrganizationUnitDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    documentTagOrganizationUnitPut(id: number, body: TenancyRequestDtoOfUpdateDocumentTagOrganizationUnitDto | undefined): Observable<DocumentTagOrganizationUnitDto>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTagOrganizationUnitDelete(id: number, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    move(id: number, body: TenancyRequestDtoOfMoveDocumentTagOrganizationUnitDto | undefined): Observable<DocumentTagOrganizationUnitDto>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    role(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagOrganizationUnitRoleDto[]>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTag(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentTagOrganizationUnitServiceProxy implements IDocumentTagOrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getList(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagOrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/manage/document-tag-organization-unit/get-list?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagOrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagOrganizationUnitDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<DocumentTagOrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagOrganizationUnitDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagOrganizationUnitDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateDocumentTagOrganizationUnitDto | undefined): Observable<DocumentTagOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/manage/document-tag-organization-unit/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagOrganizationUnitDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentTagOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagOrganizationUnitDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagOrganizationUnitDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTagOrganizationUnitGet(id: number, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/manage/document-tag-organization-unit/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentTagOrganizationUnitGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentTagOrganizationUnitGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagOrganizationUnitDto>;
        }));
    }

    protected processDocumentTagOrganizationUnitGet(response: HttpResponseBase): Observable<DocumentTagOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagOrganizationUnitDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagOrganizationUnitDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentTagOrganizationUnitPut(id: number, body: TenancyRequestDtoOfUpdateDocumentTagOrganizationUnitDto | undefined): Observable<DocumentTagOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/manage/document-tag-organization-unit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentTagOrganizationUnitPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentTagOrganizationUnitPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagOrganizationUnitDto>;
        }));
    }

    protected processDocumentTagOrganizationUnitPut(response: HttpResponseBase): Observable<DocumentTagOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagOrganizationUnitDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagOrganizationUnitDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTagOrganizationUnitDelete(id: number, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/document-tag-organization-unit/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentTagOrganizationUnitDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentTagOrganizationUnitDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDocumentTagOrganizationUnitDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    move(id: number, body: TenancyRequestDtoOfMoveDocumentTagOrganizationUnitDto | undefined): Observable<DocumentTagOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/manage/document-tag-organization-unit/{id}/move";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagOrganizationUnitDto>;
        }));
    }

    protected processMove(response: HttpResponseBase): Observable<DocumentTagOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagOrganizationUnitDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagOrganizationUnitDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    role(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagOrganizationUnitRoleDto[]> {
        let url_ = this.baseUrl + "/api/manage/document-tag-organization-unit/assignable/role?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagOrganizationUnitRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagOrganizationUnitRoleDto[]>;
        }));
    }

    protected processRole(response: HttpResponseBase): Observable<DocumentTagOrganizationUnitRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagOrganizationUnitRoleDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagOrganizationUnitRoleDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTag(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagDto[]> {
        let url_ = this.baseUrl + "/api/manage/document-tag-organization-unit/assignable/document-tag?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagDto[]>;
        }));
    }

    protected processDocumentTag(response: HttpResponseBase): Observable<DocumentTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagDto[]>(null as any);
    }
}

export interface IEmployeeArtifactServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeArtifactServiceProxy implements IEmployeeArtifactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/artifact/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IEmployeeArtifactAttachmentServiceProxy {
    /**
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<AttachmentDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    upload(body: TenancyRequestDtoOfUploadArtifactAttachment | undefined): Observable<void>;
    /**
     * @param body_AttachmentId (optional) 
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_AttachmentId: string | undefined, body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeArtifactAttachmentServiceProxy implements IEmployeeArtifactAttachmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<AttachmentDto[]> {
        let url_ = this.baseUrl + "/api/employee/artifact-attachment/get?";
        if (body_ArtifactType !== undefined && body_ArtifactType !== null)
            url_ += "Body.ArtifactType=" + encodeURIComponent("" + body_ArtifactType) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttachmentDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upload(body: TenancyRequestDtoOfUploadArtifactAttachment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/artifact-attachment/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_AttachmentId (optional) 
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_AttachmentId: string | undefined, body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/artifact-attachment/delete?";
        if (body_AttachmentId === null)
            throw new Error("The parameter 'body_AttachmentId' cannot be null.");
        else if (body_AttachmentId !== undefined)
            url_ += "Body.AttachmentId=" + encodeURIComponent("" + body_AttachmentId) + "&";
        if (body_ArtifactType !== undefined && body_ArtifactType !== null)
            url_ += "Body.ArtifactType=" + encodeURIComponent("" + body_ArtifactType) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IEmployeeArtifactMessageServiceProxy {
    /**
     * @param body_Skip (optional) 
     * @param body_Take (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Skip: number | undefined, body_Take: number | undefined, body_ArtifactType: string, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<MessageDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    append(body: TenancyRequestDtoOfAppendMessagesInputDto | undefined): Observable<MessageDto>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeArtifactMessageServiceProxy implements IEmployeeArtifactMessageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body_Skip (optional) 
     * @param body_Take (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Skip: number | undefined, body_Take: number | undefined, body_ArtifactType: string, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<MessageDto[]> {
        let url_ = this.baseUrl + "/api/employee/artifact-message/get?";
        if (body_Skip === null)
            throw new Error("The parameter 'body_Skip' cannot be null.");
        else if (body_Skip !== undefined)
            url_ += "Body.Skip=" + encodeURIComponent("" + body_Skip) + "&";
        if (body_Take === null)
            throw new Error("The parameter 'body_Take' cannot be null.");
        else if (body_Take !== undefined)
            url_ += "Body.Take=" + encodeURIComponent("" + body_Take) + "&";
        if (body_ArtifactType === undefined || body_ArtifactType === null)
            throw new Error("The parameter 'body_ArtifactType' must be defined and cannot be null.");
        else
            url_ += "Body.ArtifactType=" + encodeURIComponent("" + body_ArtifactType) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    append(body: TenancyRequestDtoOfAppendMessagesInputDto | undefined): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/employee/artifact-message/append";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processAppend(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageDto>(null as any);
    }
}

export interface IEmployeeDocumentServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    confirmationOfAcceptance(body: TenancyRequestDtoOfEntityDto | undefined): Observable<DocumentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uploadDocument(body: TenancyRequestDtoOfEmployeeUploadDocument | undefined): Observable<void>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTags(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_TagId (optional) 
     * @param body_OwnerId (optional) 
     * @param body_IsDeleted (optional) 
     * @param body_ValidTo (optional) 
     * @param body_ValidFrom (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getList(body_TagId: string | null | undefined, body_OwnerId: number | null | undefined, body_IsDeleted: boolean | null | undefined, body_ValidTo: moment.Moment | null | undefined, body_ValidFrom: moment.Moment | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentDto[]>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeDocumentServiceProxy implements IEmployeeDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmationOfAcceptance(body: TenancyRequestDtoOfEntityDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/employee/document/confirmation-of-acceptance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmationOfAcceptance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmationOfAcceptance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processConfirmationOfAcceptance(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadDocument(body: TenancyRequestDtoOfEmployeeUploadDocument | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/document/upload-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTags(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagDto[]> {
        let url_ = this.baseUrl + "/api/employee/document/get-tags?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagDto[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<DocumentTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/document/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_TagId (optional) 
     * @param body_OwnerId (optional) 
     * @param body_IsDeleted (optional) 
     * @param body_ValidTo (optional) 
     * @param body_ValidFrom (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getList(body_TagId: string | null | undefined, body_OwnerId: number | null | undefined, body_IsDeleted: boolean | null | undefined, body_ValidTo: moment.Moment | null | undefined, body_ValidFrom: moment.Moment | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/employee/document/get-list?";
        if (body_TagId !== undefined && body_TagId !== null)
            url_ += "Body.TagId=" + encodeURIComponent("" + body_TagId) + "&";
        if (body_OwnerId !== undefined && body_OwnerId !== null)
            url_ += "Body.OwnerId=" + encodeURIComponent("" + body_OwnerId) + "&";
        if (body_IsDeleted !== undefined && body_IsDeleted !== null)
            url_ += "Body.IsDeleted=" + encodeURIComponent("" + body_IsDeleted) + "&";
        if (body_ValidTo !== undefined && body_ValidTo !== null)
            url_ += "Body.ValidTo=" + encodeURIComponent(body_ValidTo ? "" + body_ValidTo.toISOString() : "") + "&";
        if (body_ValidFrom !== undefined && body_ValidFrom !== null)
            url_ += "Body.ValidFrom=" + encodeURIComponent(body_ValidFrom ? "" + body_ValidFrom.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto[]>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/employee/document/get?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/document/delete?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IEmployeeEmployeeCardServiceProxy {
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardDto>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSummary(userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardSummaryDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenancyRequestDtoOfEmployeeCardHistoryDto | undefined): Observable<EmployeeCardDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestPdfTaxDeclaration(body: TenancyRequestDto | undefined): Observable<void>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    doIHaveSignedEmployeeCard(userId: number | null | undefined, tenantId: number | null | undefined): Observable<boolean>;
    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    metadata(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardMetadataDto>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeEmployeeCardServiceProxy implements IEmployeeEmployeeCardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardDto> {
        let url_ = this.baseUrl + "/api/employee/employee-card/get?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCardDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmployeeCardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeCardDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCardDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSummary(userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardSummaryDto> {
        let url_ = this.baseUrl + "/api/employee/employee-card/get-summary?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCardSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCardSummaryDto>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<EmployeeCardSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeCardSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCardSummaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenancyRequestDtoOfEmployeeCardHistoryDto | undefined): Observable<EmployeeCardDto> {
        let url_ = this.baseUrl + "/api/employee/employee-card/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCardDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EmployeeCardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeCardDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCardDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestPdfTaxDeclaration(body: TenancyRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/employee-card/request-pdf-tax-declaration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPdfTaxDeclaration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPdfTaxDeclaration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestPdfTaxDeclaration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    doIHaveSignedEmployeeCard(userId: number | null | undefined, tenantId: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/employee/employee-card/do-i-have-signed-employee-card?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoIHaveSignedEmployeeCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoIHaveSignedEmployeeCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDoIHaveSignedEmployeeCard(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    metadata(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardMetadataDto> {
        let url_ = this.baseUrl + "/api/employee/employee-card/get/metadata?";
        if (body_VersionId !== undefined && body_VersionId !== null)
            url_ += "Body.VersionId=" + encodeURIComponent("" + body_VersionId) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCardMetadataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCardMetadataDto>;
        }));
    }

    protected processMetadata(response: HttpResponseBase): Observable<EmployeeCardMetadataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeCardMetadataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCardMetadataDto>(null as any);
    }
}

export interface IEmployeeEmployeeCardOptionsServiceProxy {
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(userId: number | null | undefined, tenantId: number | null | undefined): Observable<CompanyEmployeeCardOptionsDto>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeEmployeeCardOptionsServiceProxy implements IEmployeeEmployeeCardOptionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(userId: number | null | undefined, tenantId: number | null | undefined): Observable<CompanyEmployeeCardOptionsDto> {
        let url_ = this.baseUrl + "/api/employee/employee-card-options/get?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyEmployeeCardOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyEmployeeCardOptionsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyEmployeeCardOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyEmployeeCardOptionsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyEmployeeCardOptionsDto>(null as any);
    }
}

export interface IEmployeeGeneralArtifactServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateGeneralArtifactInputDto | undefined): Observable<number>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<GeneralArtifactDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setOpenState(body: TenancyRequestDtoOfEntityDto | undefined): Observable<GeneralArtifactDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setClosedState(body: TenancyRequestDtoOfEntityDto | undefined): Observable<GeneralArtifactDto>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeGeneralArtifactServiceProxy implements IEmployeeGeneralArtifactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateGeneralArtifactInputDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/employee/general-artifact/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/general-artifact/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<GeneralArtifactDto> {
        let url_ = this.baseUrl + "/api/employee/general-artifact/get?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralArtifactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralArtifactDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GeneralArtifactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralArtifactDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralArtifactDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setOpenState(body: TenancyRequestDtoOfEntityDto | undefined): Observable<GeneralArtifactDto> {
        let url_ = this.baseUrl + "/api/employee/general-artifact/set-open-state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOpenState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOpenState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralArtifactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralArtifactDto>;
        }));
    }

    protected processSetOpenState(response: HttpResponseBase): Observable<GeneralArtifactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralArtifactDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralArtifactDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setClosedState(body: TenancyRequestDtoOfEntityDto | undefined): Observable<GeneralArtifactDto> {
        let url_ = this.baseUrl + "/api/employee/general-artifact/set-closed-state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetClosedState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetClosedState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralArtifactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralArtifactDto>;
        }));
    }

    protected processSetClosedState(response: HttpResponseBase): Observable<GeneralArtifactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralArtifactDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralArtifactDto>(null as any);
    }
}

export interface IEmployeeHintsServiceProxy {
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeHints>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeHintsServiceProxy implements IEmployeeHintsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeHints> {
        let url_ = this.baseUrl + "/api/employee-hint/get?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeHints>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeHints>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmployeeHints> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeHints;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeHints>(null as any);
    }
}

export interface IEmployeePayrollServiceProxy {
    /**
     * @return Success
     */
    justForGenerateDtoPayrollDto(): Observable<PayrollDto>;
    /**
     * @return Success
     */
    justForGenerateDtoEmployeePayrollDto(): Observable<EmployeePayrollDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeePayrollServiceProxy implements IEmployeePayrollServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    justForGenerateDtoPayrollDto(): Observable<PayrollDto> {
        let url_ = this.baseUrl + "/api/employee/payroll/just-for-generate-dto-PayrollDto";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJustForGenerateDtoPayrollDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJustForGenerateDtoPayrollDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollDto>;
        }));
    }

    protected processJustForGenerateDtoPayrollDto(response: HttpResponseBase): Observable<PayrollDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollDto>(null as any);
    }

    /**
     * @return Success
     */
    justForGenerateDtoEmployeePayrollDto(): Observable<EmployeePayrollDto> {
        let url_ = this.baseUrl + "/api/employee/payroll/just-for-generate-dto-EmployeePayrollDto";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJustForGenerateDtoEmployeePayrollDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJustForGenerateDtoEmployeePayrollDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePayrollDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePayrollDto>;
        }));
    }

    protected processJustForGenerateDtoEmployeePayrollDto(response: HttpResponseBase): Observable<EmployeePayrollDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeePayrollDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePayrollDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/payroll/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IEmployeeTaxAnnualSettlementServiceProxy {
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    signTaxAnnualSettlement(body: TenancyRequestDtoOfSignRzdInputDto | undefined): Observable<RzdDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveWithoutSign(body: TenancyRequestDtoOfRzdHistoryDto | undefined): Observable<RzdDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    metadata(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdMetadataDto>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeTaxAnnualSettlementServiceProxy implements IEmployeeTaxAnnualSettlementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdDto> {
        let url_ = this.baseUrl + "/api/employee/tax-annual-settlement/get?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RzdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signTaxAnnualSettlement(body: TenancyRequestDtoOfSignRzdInputDto | undefined): Observable<RzdDto> {
        let url_ = this.baseUrl + "/api/employee/tax-annual-settlement/sign-tax-annual-settlement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignTaxAnnualSettlement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignTaxAnnualSettlement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdDto>;
        }));
    }

    protected processSignTaxAnnualSettlement(response: HttpResponseBase): Observable<RzdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveWithoutSign(body: TenancyRequestDtoOfRzdHistoryDto | undefined): Observable<RzdDto> {
        let url_ = this.baseUrl + "/api/employee/tax-annual-settlement/save-without-sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveWithoutSign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveWithoutSign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdDto>;
        }));
    }

    protected processSaveWithoutSign(response: HttpResponseBase): Observable<RzdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/employee/tax-annual-settlement/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    metadata(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdMetadataDto> {
        let url_ = this.baseUrl + "/api/employee/tax-annual-settlement/get/metadata?";
        if (body_VersionId !== undefined && body_VersionId !== null)
            url_ += "Body.VersionId=" + encodeURIComponent("" + body_VersionId) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdMetadataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdMetadataDto>;
        }));
    }

    protected processMetadata(response: HttpResponseBase): Observable<RzdMetadataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdMetadataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdMetadataDto>(null as any);
    }
}

export interface IEtlServiceProxy {
    /**
     * @return Success
     */
    processEtl(): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataManagerRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    insertJournal(body: InsertJournalInputDto | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateState(id: number, body: UpdateJournalState | undefined): Observable<void>;
    /**
     * @return Success
     */
    duplicateJournalRow(id: number): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EtlServiceProxy implements IEtlServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    processEtl(): Observable<void> {
        let url_ = this.baseUrl + "/api/etl/process-etl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessEtl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessEtl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessEtl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataManagerRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/etl/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertJournal(body: InsertJournalInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/etl/insert-journal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertJournal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertJournal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateState(id: number, body: UpdateJournalState | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/etl/{id}/update-state";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    duplicateJournalRow(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/etl/{id}/duplicate-journal-row";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateJournalRow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateJournalRow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDuplicateJournalRow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IHotfixesServiceProxy {
    /**
     * @return Success
     */
    hotfixEmployeeCardApprovedBy(): Observable<string>;
    /**
     * @return Success
     */
    hotfixEmployeeCardOwnerId(): Observable<string>;
    /**
     * @return Success
     */
    hotfixDatesFormats(): Observable<string>;
    /**
     * @return Success
     */
    auditLogCheck(): Observable<string>;
    /**
     * @return Success
     */
    rzdJournalsSync(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class HotfixesServiceProxy implements IHotfixesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    hotfixEmployeeCardApprovedBy(): Observable<string> {
        let url_ = this.baseUrl + "/api/hotfix/hotfix-employee-card-approved-by";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHotfixEmployeeCardApprovedBy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHotfixEmployeeCardApprovedBy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processHotfixEmployeeCardApprovedBy(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    hotfixEmployeeCardOwnerId(): Observable<string> {
        let url_ = this.baseUrl + "/api/hotfix/hotfix-employee-card-owner-id";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHotfixEmployeeCardOwnerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHotfixEmployeeCardOwnerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processHotfixEmployeeCardOwnerId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    hotfixDatesFormats(): Observable<string> {
        let url_ = this.baseUrl + "/api/hotfix/hotfix-dates-formats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHotfixDatesFormats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHotfixDatesFormats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processHotfixDatesFormats(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    auditLogCheck(): Observable<string> {
        let url_ = this.baseUrl + "/api/hotfix/audit-log-check";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuditLogCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuditLogCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAuditLogCheck(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    rzdJournalsSync(): Observable<string> {
        let url_ = this.baseUrl + "/api/hotfix/rzd-journals-sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRzdJournalsSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRzdJournalsSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRzdJournalsSync(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IHtmlToPdfServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    htmlToPdf(body: HtmlToPdfDto | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    multipleHtmlToPdf(body: MultipleHtmlToPdfDto | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class HtmlToPdfServiceProxy implements IHtmlToPdfServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    htmlToPdf(body: HtmlToPdfDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/HtmlToPdf/HtmlToPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHtmlToPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHtmlToPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHtmlToPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    multipleHtmlToPdf(body: MultipleHtmlToPdfDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/HtmlToPdf/MultipleHtmlToPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMultipleHtmlToPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMultipleHtmlToPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMultipleHtmlToPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IManageAnnouncementServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<AnnouncementDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfAnnouncementDto | undefined): Observable<AnnouncementDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenancyRequestDtoOfAnnouncementDto | undefined): Observable<AnnouncementDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EntityDtoOfGuid>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sendAnnouncement(body: TenancyRequestDtoOfSendAnnouncementDto | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class ManageAnnouncementServiceProxy implements IManageAnnouncementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/announcement/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<AnnouncementDto> {
        let url_ = this.baseUrl + "/api/manage/announcement/get?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnouncementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnouncementDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AnnouncementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnouncementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnouncementDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfAnnouncementDto | undefined): Observable<AnnouncementDto> {
        let url_ = this.baseUrl + "/api/manage/announcement/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnouncementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnouncementDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AnnouncementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnouncementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnouncementDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenancyRequestDtoOfAnnouncementDto | undefined): Observable<AnnouncementDto> {
        let url_ = this.baseUrl + "/api/manage/announcement/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AnnouncementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AnnouncementDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AnnouncementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnnouncementDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnouncementDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EntityDtoOfGuid> {
        let url_ = this.baseUrl + "/api/manage/announcement/delete?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityDtoOfGuid>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityDtoOfGuid>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<EntityDtoOfGuid> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityDtoOfGuid;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityDtoOfGuid>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendAnnouncement(body: TenancyRequestDtoOfSendAnnouncementDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/manage/announcement/send-announcement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAnnouncement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAnnouncement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendAnnouncement(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

export interface IManageArtifactAttachmentServiceProxy {
    /**
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<AttachmentDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    upload(body: TenancyRequestDtoOfUploadArtifactAttachment | undefined): Observable<void>;
    /**
     * @param body_AttachmentId (optional) 
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_AttachmentId: string | undefined, body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ManageArtifactAttachmentServiceProxy implements IManageArtifactAttachmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<AttachmentDto[]> {
        let url_ = this.baseUrl + "/api/manage/artifact-attachment/get?";
        if (body_ArtifactType !== undefined && body_ArtifactType !== null)
            url_ += "Body.ArtifactType=" + encodeURIComponent("" + body_ArtifactType) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttachmentDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upload(body: TenancyRequestDtoOfUploadArtifactAttachment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/artifact-attachment/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_AttachmentId (optional) 
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_AttachmentId: string | undefined, body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/artifact-attachment/delete?";
        if (body_AttachmentId === null)
            throw new Error("The parameter 'body_AttachmentId' cannot be null.");
        else if (body_AttachmentId !== undefined)
            url_ += "Body.AttachmentId=" + encodeURIComponent("" + body_AttachmentId) + "&";
        if (body_ArtifactType !== undefined && body_ArtifactType !== null)
            url_ += "Body.ArtifactType=" + encodeURIComponent("" + body_ArtifactType) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IManageArtifactMessageServiceProxy {
    /**
     * @param body_Skip (optional) 
     * @param body_Take (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Skip: number | undefined, body_Take: number | undefined, body_ArtifactType: string, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<MessageDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    append(body: TenancyRequestDtoOfAppendMessagesInputDto | undefined): Observable<MessageDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ManageArtifactMessageServiceProxy implements IManageArtifactMessageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body_Skip (optional) 
     * @param body_Take (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Skip: number | undefined, body_Take: number | undefined, body_ArtifactType: string, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<MessageDto[]> {
        let url_ = this.baseUrl + "/api/manage/artifact-message/get?";
        if (body_Skip === null)
            throw new Error("The parameter 'body_Skip' cannot be null.");
        else if (body_Skip !== undefined)
            url_ += "Body.Skip=" + encodeURIComponent("" + body_Skip) + "&";
        if (body_Take === null)
            throw new Error("The parameter 'body_Take' cannot be null.");
        else if (body_Take !== undefined)
            url_ += "Body.Take=" + encodeURIComponent("" + body_Take) + "&";
        if (body_ArtifactType === undefined || body_ArtifactType === null)
            throw new Error("The parameter 'body_ArtifactType' must be defined and cannot be null.");
        else
            url_ += "Body.ArtifactType=" + encodeURIComponent("" + body_ArtifactType) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    append(body: TenancyRequestDtoOfAppendMessagesInputDto | undefined): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/manage/artifact-message/append";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processAppend(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageDto>(null as any);
    }
}

export interface IManageDocumentServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    approveDocument(body: TenancyRequestDtoOfApproveDocumentDto | undefined): Observable<DocumentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    recoverDocument(body: TenancyRequestDtoOfEntityDto | undefined): Observable<DocumentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocumentTag(body: TenancyRequestDtoOfUpdateDocumentTagDto | undefined): Observable<DocumentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    duplicateDocument(body: TenancyRequestDtoOfUpdateDocumentTagDto | undefined): Observable<DocumentDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uploadDocument(body: TenancyRequestDtoOfUploadDocument | undefined): Observable<void>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTags(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_TagId (optional) 
     * @param body_OwnerId (optional) 
     * @param body_IsDeleted (optional) 
     * @param body_ValidTo (optional) 
     * @param body_ValidFrom (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getList(body_TagId: string | null | undefined, body_OwnerId: number | null | undefined, body_IsDeleted: boolean | null | undefined, body_ValidTo: moment.Moment | null | undefined, body_ValidFrom: moment.Moment | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentDto[]>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ManageDocumentServiceProxy implements IManageDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveDocument(body: TenancyRequestDtoOfApproveDocumentDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/manage/document/approve-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processApproveDocument(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recoverDocument(body: TenancyRequestDtoOfEntityDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/manage/document/recover-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecoverDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processRecoverDocument(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocumentTag(body: TenancyRequestDtoOfUpdateDocumentTagDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/manage/document/update-document-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processUpdateDocumentTag(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    duplicateDocument(body: TenancyRequestDtoOfUpdateDocumentTagDto | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/manage/document/duplicate-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processDuplicateDocument(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadDocument(body: TenancyRequestDtoOfUploadDocument | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/document/upload-document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTags(userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagDto[]> {
        let url_ = this.baseUrl + "/api/manage/document/get-tags?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagDto[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<DocumentTagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/document/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_TagId (optional) 
     * @param body_OwnerId (optional) 
     * @param body_IsDeleted (optional) 
     * @param body_ValidTo (optional) 
     * @param body_ValidFrom (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getList(body_TagId: string | null | undefined, body_OwnerId: number | null | undefined, body_IsDeleted: boolean | null | undefined, body_ValidTo: moment.Moment | null | undefined, body_ValidFrom: moment.Moment | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/manage/document/get-list?";
        if (body_TagId !== undefined && body_TagId !== null)
            url_ += "Body.TagId=" + encodeURIComponent("" + body_TagId) + "&";
        if (body_OwnerId !== undefined && body_OwnerId !== null)
            url_ += "Body.OwnerId=" + encodeURIComponent("" + body_OwnerId) + "&";
        if (body_IsDeleted !== undefined && body_IsDeleted !== null)
            url_ += "Body.IsDeleted=" + encodeURIComponent("" + body_IsDeleted) + "&";
        if (body_ValidTo !== undefined && body_ValidTo !== null)
            url_ += "Body.ValidTo=" + encodeURIComponent(body_ValidTo ? "" + body_ValidTo.toISOString() : "") + "&";
        if (body_ValidFrom !== undefined && body_ValidFrom !== null)
            url_ += "Body.ValidFrom=" + encodeURIComponent(body_ValidFrom ? "" + body_ValidFrom.toISOString() : "") + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto[]>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/manage/document/get?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/document/delete?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IManageDocumentTagServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTagGet(id: string | null, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagWithTranslationsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    documentTagPut(id: string | null, body: TenancyRequestDtoOfDocumentTagInputDto | undefined): Observable<DocumentTagWithTranslationsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    documentTagPost(body: TenancyRequestDtoOfDocumentTagInputDto | undefined): Observable<DocumentTagWithTranslationsDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTagDelete(body_Id: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ManageDocumentTagServiceProxy implements IManageDocumentTagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/document-tag/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTagGet(id: string | null, userId: number | null | undefined, tenantId: number | null | undefined): Observable<DocumentTagWithTranslationsDto> {
        let url_ = this.baseUrl + "/api/manage/document-tag/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentTagGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentTagGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagWithTranslationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagWithTranslationsDto>;
        }));
    }

    protected processDocumentTagGet(response: HttpResponseBase): Observable<DocumentTagWithTranslationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagWithTranslationsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagWithTranslationsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentTagPut(id: string | null, body: TenancyRequestDtoOfDocumentTagInputDto | undefined): Observable<DocumentTagWithTranslationsDto> {
        let url_ = this.baseUrl + "/api/manage/document-tag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentTagPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentTagPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagWithTranslationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagWithTranslationsDto>;
        }));
    }

    protected processDocumentTagPut(response: HttpResponseBase): Observable<DocumentTagWithTranslationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagWithTranslationsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagWithTranslationsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentTagPost(body: TenancyRequestDtoOfDocumentTagInputDto | undefined): Observable<DocumentTagWithTranslationsDto> {
        let url_ = this.baseUrl + "/api/manage/document-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentTagPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentTagPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTagWithTranslationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTagWithTranslationsDto>;
        }));
    }

    protected processDocumentTagPost(response: HttpResponseBase): Observable<DocumentTagWithTranslationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTagWithTranslationsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTagWithTranslationsDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    documentTagDelete(body_Id: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/document-tag?";
        if (body_Id !== undefined && body_Id !== null)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentTagDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentTagDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDocumentTagDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IManageEmployeeCardServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<ExtendedEmployeeCardDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSummary(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardSummaryDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getHistory(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardHistoryListDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestPdfTaxDeclaration(body: TenancyRequestDtoOfEntityDto | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    toggleWarning(body: TenancyRequestDtoOfEntityDto | undefined): Observable<boolean>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: TenancyRequestDtoOfApproveOrReturnEmployeeCard | undefined): Observable<ExtendedEmployeeCardDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    return(body: TenancyRequestDtoOfApproveOrReturnEmployeeCard | undefined): Observable<ExtendedEmployeeCardDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    noteGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    notePut(body: TenancyRequestDtoOfUpdateEmployeeCardNoteInput | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateEmployeeCardDto | undefined): Observable<number>;
    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    metadata(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardMetadataDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ManageEmployeeCardServiceProxy implements IManageEmployeeCardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/employee-card/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<ExtendedEmployeeCardDto> {
        let url_ = this.baseUrl + "/api/manage/employee-card/get?";
        if (body_VersionId !== undefined && body_VersionId !== null)
            url_ += "Body.VersionId=" + encodeURIComponent("" + body_VersionId) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendedEmployeeCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendedEmployeeCardDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ExtendedEmployeeCardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedEmployeeCardDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExtendedEmployeeCardDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSummary(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardSummaryDto> {
        let url_ = this.baseUrl + "/api/manage/employee-card/get-summary?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCardSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCardSummaryDto>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<EmployeeCardSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeCardSummaryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCardSummaryDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getHistory(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardHistoryListDto[]> {
        let url_ = this.baseUrl + "/api/manage/employee-card/get-history?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCardHistoryListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCardHistoryListDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<EmployeeCardHistoryListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeCardHistoryListDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCardHistoryListDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestPdfTaxDeclaration(body: TenancyRequestDtoOfEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/employee-card/request-pdf-tax-declaration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestPdfTaxDeclaration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPdfTaxDeclaration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestPdfTaxDeclaration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleWarning(body: TenancyRequestDtoOfEntityDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/manage/employee-card/toggle-warning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleWarning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleWarning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processToggleWarning(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: TenancyRequestDtoOfApproveOrReturnEmployeeCard | undefined): Observable<ExtendedEmployeeCardDto> {
        let url_ = this.baseUrl + "/api/manage/employee-card/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendedEmployeeCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendedEmployeeCardDto>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<ExtendedEmployeeCardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedEmployeeCardDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExtendedEmployeeCardDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    return(body: TenancyRequestDtoOfApproveOrReturnEmployeeCard | undefined): Observable<ExtendedEmployeeCardDto> {
        let url_ = this.baseUrl + "/api/manage/employee-card/return";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendedEmployeeCardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendedEmployeeCardDto>;
        }));
    }

    protected processReturn(response: HttpResponseBase): Observable<ExtendedEmployeeCardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendedEmployeeCardDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExtendedEmployeeCardDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    noteGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/manage/employee-card/get/note?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNoteGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNoteGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processNoteGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notePut(body: TenancyRequestDtoOfUpdateEmployeeCardNoteInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/employee-card/update/note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotePut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotePut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotePut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateEmployeeCardDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/manage/employee-card/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    metadata(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmployeeCardMetadataDto> {
        let url_ = this.baseUrl + "/api/manage/employee-card/get/metadata?";
        if (body_VersionId !== undefined && body_VersionId !== null)
            url_ += "Body.VersionId=" + encodeURIComponent("" + body_VersionId) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCardMetadataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCardMetadataDto>;
        }));
    }

    protected processMetadata(response: HttpResponseBase): Observable<EmployeeCardMetadataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeCardMetadataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCardMetadataDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/employee-card/delete?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IManageGeneralArtifactServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateGeneralArtifactForUserInputDto | undefined): Observable<number>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<GeneralArtifactDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setOpenState(body: TenancyRequestDtoOfEntityDto | undefined): Observable<GeneralArtifactDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setClosedState(body: TenancyRequestDtoOfEntityDto | undefined): Observable<GeneralArtifactDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ManageGeneralArtifactServiceProxy implements IManageGeneralArtifactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateGeneralArtifactForUserInputDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/manage/general-artifact/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/general-artifact/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<GeneralArtifactDto> {
        let url_ = this.baseUrl + "/api/manage/general-artifact/get?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralArtifactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralArtifactDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GeneralArtifactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralArtifactDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralArtifactDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setOpenState(body: TenancyRequestDtoOfEntityDto | undefined): Observable<GeneralArtifactDto> {
        let url_ = this.baseUrl + "/api/manage/general-artifact/set-open-state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOpenState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOpenState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralArtifactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralArtifactDto>;
        }));
    }

    protected processSetOpenState(response: HttpResponseBase): Observable<GeneralArtifactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralArtifactDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralArtifactDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setClosedState(body: TenancyRequestDtoOfEntityDto | undefined): Observable<GeneralArtifactDto> {
        let url_ = this.baseUrl + "/api/manage/general-artifact/set-closed-state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetClosedState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetClosedState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralArtifactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralArtifactDto>;
        }));
    }

    protected processSetClosedState(response: HttpResponseBase): Observable<GeneralArtifactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeneralArtifactDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralArtifactDto>(null as any);
    }
}

export interface IManagePayrollServiceProxy {
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    payroll(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ManagePayrollServiceProxy implements IManagePayrollServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    payroll(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/payroll?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayroll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayroll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPayroll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/payroll/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IManageTaxAnnualSettlementServiceProxy {
    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateRzdInput | undefined): Observable<number>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getHistory(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdHistoryListDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: TenancyRequestDtoOfRzdOperationInputDto | undefined): Observable<RzdDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    return(body: TenancyRequestDtoOfRzdOperationInputDto | undefined): Observable<RzdDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getDates(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdDatesDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateDates(body: TenancyRequestDtoOfRzdDatesDto | undefined): Observable<RzdDatesDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    metadata(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdMetadataDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ManageTaxAnnualSettlementServiceProxy implements IManageTaxAnnualSettlementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdDto> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/get?";
        if (body_VersionId !== undefined && body_VersionId !== null)
            url_ += "Body.VersionId=" + encodeURIComponent("" + body_VersionId) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RzdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateRzdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getHistory(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdHistoryListDto[]> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/get-history?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdHistoryListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdHistoryListDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<RzdHistoryListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdHistoryListDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdHistoryListDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: TenancyRequestDtoOfRzdOperationInputDto | undefined): Observable<RzdDto> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdDto>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<RzdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    return(body: TenancyRequestDtoOfRzdOperationInputDto | undefined): Observable<RzdDto> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/return";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdDto>;
        }));
    }

    protected processReturn(response: HttpResponseBase): Observable<RzdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getDates(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdDatesDto> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/get-dates?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdDatesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdDatesDto>;
        }));
    }

    protected processGetDates(response: HttpResponseBase): Observable<RzdDatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdDatesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdDatesDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDates(body: TenancyRequestDtoOfRzdDatesDto | undefined): Observable<RzdDatesDto> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/update-dates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdDatesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdDatesDto>;
        }));
    }

    protected processUpdateDates(response: HttpResponseBase): Observable<RzdDatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdDatesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdDatesDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/delete?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_VersionId (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    metadata(body_VersionId: number | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<RzdMetadataDto> {
        let url_ = this.baseUrl + "/api/manage/tax-annual-settlement/get/metadata?";
        if (body_VersionId !== undefined && body_VersionId !== null)
            url_ += "Body.VersionId=" + encodeURIComponent("" + body_VersionId) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RzdMetadataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RzdMetadataDto>;
        }));
    }

    protected processMetadata(response: HttpResponseBase): Observable<RzdMetadataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RzdMetadataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RzdMetadataDto>(null as any);
    }
}

export interface IMangeOnboardingServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<OnboardingRequestExtendedDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateOnboardingRequestInputDto | undefined): Observable<OnboardingRequestExtendedDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: TenancyRequestDtoOfGuid | undefined): Observable<OnboardingRequestExtendedDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    markUserCreated(body: TenancyRequestDtoOfGuid | undefined): Observable<OnboardingRequestExtendedDto>;
    /**
     * @param body (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAdditionalForm(userId: number | null | undefined, tenantId: number | null | undefined): Observable<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateAdditionalForm(body: TenancyRequestDtoOfUpdateAdditionalFromInputDto | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class MangeOnboardingServiceProxy implements IMangeOnboardingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/onboarding/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<OnboardingRequestExtendedDto> {
        let url_ = this.baseUrl + "/api/manage/onboarding/get?";
        if (body === null)
            throw new Error("The parameter 'body' cannot be null.");
        else if (body !== undefined)
            url_ += "Body=" + encodeURIComponent("" + body) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingRequestExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingRequestExtendedDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OnboardingRequestExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnboardingRequestExtendedDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingRequestExtendedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateOnboardingRequestInputDto | undefined): Observable<OnboardingRequestExtendedDto> {
        let url_ = this.baseUrl + "/api/manage/onboarding/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingRequestExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingRequestExtendedDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OnboardingRequestExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnboardingRequestExtendedDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingRequestExtendedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: TenancyRequestDtoOfGuid | undefined): Observable<OnboardingRequestExtendedDto> {
        let url_ = this.baseUrl + "/api/manage/onboarding/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingRequestExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingRequestExtendedDto>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<OnboardingRequestExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnboardingRequestExtendedDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingRequestExtendedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markUserCreated(body: TenancyRequestDtoOfGuid | undefined): Observable<OnboardingRequestExtendedDto> {
        let url_ = this.baseUrl + "/api/manage/onboarding/mark-user-created";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkUserCreated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkUserCreated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingRequestExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingRequestExtendedDto>;
        }));
    }

    protected processMarkUserCreated(response: HttpResponseBase): Observable<OnboardingRequestExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnboardingRequestExtendedDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingRequestExtendedDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/manage/onboarding/delete?";
        if (body === null)
            throw new Error("The parameter 'body' cannot be null.");
        else if (body !== undefined)
            url_ += "Body=" + encodeURIComponent("" + body) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAdditionalForm(userId: number | null | undefined, tenantId: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/manage/onboarding/get-additional-form?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdditionalForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdditionalForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAdditionalForm(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAdditionalForm(body: TenancyRequestDtoOfUpdateAdditionalFromInputDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/manage/onboarding/update-additional-form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAdditionalForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAdditionalForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateAdditionalForm(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IMangeOnboardingNotesServiceProxy {
    /**
     * @param body (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<OnboardingRequestNoteDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateOnboardingRequestNoteInputDto | undefined): Observable<OnboardingRequestNoteDto>;
}

@Injectable({
    providedIn: 'root'
})
export class MangeOnboardingNotesServiceProxy implements IMangeOnboardingNotesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body: string | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<OnboardingRequestNoteDto[]> {
        let url_ = this.baseUrl + "/api/manage/onboarding-notes/get?";
        if (body === null)
            throw new Error("The parameter 'body' cannot be null.");
        else if (body !== undefined)
            url_ += "Body=" + encodeURIComponent("" + body) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingRequestNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingRequestNoteDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OnboardingRequestNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnboardingRequestNoteDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingRequestNoteDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreateOnboardingRequestNoteInputDto | undefined): Observable<OnboardingRequestNoteDto> {
        let url_ = this.baseUrl + "/api/manage/onboarding-notes/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingRequestNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingRequestNoteDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OnboardingRequestNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnboardingRequestNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingRequestNoteDto>(null as any);
    }
}

export interface INotificationServiceProxy {
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    settings(userId: number | null | undefined, tenantId: number | null | undefined): Observable<GetNotificationSettingsOutput>;
    /**
     * @param body_State (optional) 
     * @param body_StartDate (optional) 
     * @param body_EndDate (optional) 
     * @param body_MaxResultCount (optional) 
     * @param body_SkipCount (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_State: UserNotificationState | undefined, body_StartDate: moment.Moment | null | undefined, body_EndDate: moment.Moment | null | undefined, body_MaxResultCount: number | undefined, body_SkipCount: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<GetNotificationsOutput>;
    /**
     * @param body (optional) 
     * @return Success
     */
    markAsRead(body: TenancyRequestDtoOfEntityDtoOfGuid | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    markAllAsRead(body: TenancyRequestDto | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationServiceProxy implements INotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    settings(userId: number | null | undefined, tenantId: number | null | undefined): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/notification/get/settings?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }));
    }

    protected processSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNotificationSettingsOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationSettingsOutput>(null as any);
    }

    /**
     * @param body_State (optional) 
     * @param body_StartDate (optional) 
     * @param body_EndDate (optional) 
     * @param body_MaxResultCount (optional) 
     * @param body_SkipCount (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_State: UserNotificationState | undefined, body_StartDate: moment.Moment | null | undefined, body_EndDate: moment.Moment | null | undefined, body_MaxResultCount: number | undefined, body_SkipCount: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/notification/get?";
        if (body_State === null)
            throw new Error("The parameter 'body_State' cannot be null.");
        else if (body_State !== undefined)
            url_ += "Body.State=" + encodeURIComponent("" + body_State) + "&";
        if (body_StartDate !== undefined && body_StartDate !== null)
            url_ += "Body.StartDate=" + encodeURIComponent(body_StartDate ? "" + body_StartDate.toISOString() : "") + "&";
        if (body_EndDate !== undefined && body_EndDate !== null)
            url_ += "Body.EndDate=" + encodeURIComponent(body_EndDate ? "" + body_EndDate.toISOString() : "") + "&";
        if (body_MaxResultCount === null)
            throw new Error("The parameter 'body_MaxResultCount' cannot be null.");
        else if (body_MaxResultCount !== undefined)
            url_ += "Body.MaxResultCount=" + encodeURIComponent("" + body_MaxResultCount) + "&";
        if (body_SkipCount === null)
            throw new Error("The parameter 'body_SkipCount' cannot be null.");
        else if (body_SkipCount !== undefined)
            url_ += "Body.SkipCount=" + encodeURIComponent("" + body_SkipCount) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNotificationsOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationsOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAsRead(body: TenancyRequestDtoOfEntityDtoOfGuid | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/notification/mark-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAllAsRead(body: TenancyRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/notification/mark-all-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAllAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IPayrollRecapServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<PayrollRecapDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreatePayrollRecapInputDto | undefined): Observable<number>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: TenancyRequestDtoOfPayrollRecapOperationInputDto | undefined): Observable<PayrollRecapDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    invalidate(body: TenancyRequestDtoOfPayrollRecapOperationInputDto | undefined): Observable<PayrollRecapDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    reject(body: TenancyRequestDtoOfPayrollRecapOperationInputDto | undefined): Observable<PayrollRecapDto>;
    /**
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    attachmentsGet(body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<AttachmentDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    attachmentsPost(body: TenancyRequestDtoOfUploadArtifactAttachment | undefined): Observable<void>;
    /**
     * @param body_Skip (optional) 
     * @param body_Take (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    messagesGet(body_Skip: number | undefined, body_Take: number | undefined, body_ArtifactType: string, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<MessageDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    messagesPut(body: TenancyRequestDtoOfAppendMessagesInputDto | undefined): Observable<MessageDto>;
}

@Injectable({
    providedIn: 'root'
})
export class PayrollRecapServiceProxy implements IPayrollRecapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/payroll-recap/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<PayrollRecapDto> {
        let url_ = this.baseUrl + "/api/payroll-recap/get?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollRecapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollRecapDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PayrollRecapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollRecapDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollRecapDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TenancyRequestDtoOfCreatePayrollRecapInputDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/payroll-recap/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: TenancyRequestDtoOfPayrollRecapOperationInputDto | undefined): Observable<PayrollRecapDto> {
        let url_ = this.baseUrl + "/api/payroll-recap/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollRecapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollRecapDto>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<PayrollRecapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollRecapDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollRecapDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    invalidate(body: TenancyRequestDtoOfPayrollRecapOperationInputDto | undefined): Observable<PayrollRecapDto> {
        let url_ = this.baseUrl + "/api/payroll-recap/invalidate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvalidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvalidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollRecapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollRecapDto>;
        }));
    }

    protected processInvalidate(response: HttpResponseBase): Observable<PayrollRecapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollRecapDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollRecapDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reject(body: TenancyRequestDtoOfPayrollRecapOperationInputDto | undefined): Observable<PayrollRecapDto> {
        let url_ = this.baseUrl + "/api/payroll-recap/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollRecapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollRecapDto>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<PayrollRecapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayrollRecapDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollRecapDto>(null as any);
    }

    /**
     * @param body_ArtifactType (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    attachmentsGet(body_ArtifactType: string | null | undefined, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<AttachmentDto[]> {
        let url_ = this.baseUrl + "/api/payroll-recap/get/attachments?";
        if (body_ArtifactType !== undefined && body_ArtifactType !== null)
            url_ += "Body.ArtifactType=" + encodeURIComponent("" + body_ArtifactType) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDto[]>;
        }));
    }

    protected processAttachmentsGet(response: HttpResponseBase): Observable<AttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttachmentDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    attachmentsPost(body: TenancyRequestDtoOfUploadArtifactAttachment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/payroll-recap/upload/attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttachmentsPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Skip (optional) 
     * @param body_Take (optional) 
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    messagesGet(body_Skip: number | undefined, body_Take: number | undefined, body_ArtifactType: string, body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<MessageDto[]> {
        let url_ = this.baseUrl + "/api/payroll-recap/get/messages?";
        if (body_Skip === null)
            throw new Error("The parameter 'body_Skip' cannot be null.");
        else if (body_Skip !== undefined)
            url_ += "Body.Skip=" + encodeURIComponent("" + body_Skip) + "&";
        if (body_Take === null)
            throw new Error("The parameter 'body_Take' cannot be null.");
        else if (body_Take !== undefined)
            url_ += "Body.Take=" + encodeURIComponent("" + body_Take) + "&";
        if (body_ArtifactType === undefined || body_ArtifactType === null)
            throw new Error("The parameter 'body_ArtifactType' must be defined and cannot be null.");
        else
            url_ += "Body.ArtifactType=" + encodeURIComponent("" + body_ArtifactType) + "&";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessagesGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessagesGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto[]>;
        }));
    }

    protected processMessagesGet(response: HttpResponseBase): Observable<MessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    messagesPut(body: TenancyRequestDtoOfAppendMessagesInputDto | undefined): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/payroll-recap/append/messages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessagesPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessagesPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processMessagesPut(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageDto>(null as any);
    }
}

export interface IProfileServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void>;
    /**
     * @return Success
     */
    getPasswordComplexitySettings(): Observable<GetPasswordComplexitySettingOutput>;
    /**
     * @return Success
     */
    getCurrentUserProfile(): Observable<TpaCurrentUserProfileEditDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sendVerificationSmsCode(body: RequestSmsVerificationCodeInput | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    enableTwoFactorAuth(body: TwoFactorValidationInput | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    disableTwoFactorAuth(body: DisableTwoFactorValidationInput | undefined): Observable<void>;
    /**
     * @return Success
     */
    updateGoogleAuthenticationKey(): Observable<TpaUpdateGoogleAuthenticatorKeyOutput>;
}

@Injectable({
    providedIn: 'root'
})
export class ProfileServiceProxy implements IProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/profile/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/profile/change-language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySettings(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/profile/get-password-complexity-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySettings(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPasswordComplexitySettingOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPasswordComplexitySettingOutput>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentUserProfile(): Observable<TpaCurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/profile/get-current-user-profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TpaCurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TpaCurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfile(response: HttpResponseBase): Observable<TpaCurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TpaCurrentUserProfileEditDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TpaCurrentUserProfileEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendVerificationSmsCode(body: RequestSmsVerificationCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/profile/send-verification-sms-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    enableTwoFactorAuth(body: TwoFactorValidationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/profile/enable-two-factor-auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableTwoFactorAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableTwoFactorAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableTwoFactorAuth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disableTwoFactorAuth(body: DisableTwoFactorValidationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/profile/disable-two-factor-auth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableTwoFactorAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableTwoFactorAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableTwoFactorAuth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticationKey(): Observable<TpaUpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/profile/update-google-authentication-key";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticationKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticationKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TpaUpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TpaUpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticationKey(response: HttpResponseBase): Observable<TpaUpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TpaUpdateGoogleAuthenticatorKeyOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TpaUpdateGoogleAuthenticatorKeyOutput>(null as any);
    }
}

export interface IPublicOnboardingServiceProxy {
    /**
     * @param body (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body: string | undefined, tenantId: number | undefined): Observable<OnboardingRequestDto>;
    /**
     * @param body (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAdditionalForm(body: string | undefined, tenantId: number | undefined): Observable<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: AnonymousTenancyRequestDtoOfSubmitOnboardingRequestInputDto | undefined): Observable<OnboardingRequestDto>;
}

@Injectable({
    providedIn: 'root'
})
export class PublicOnboardingServiceProxy implements IPublicOnboardingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body: string | undefined, tenantId: number | undefined): Observable<OnboardingRequestDto> {
        let url_ = this.baseUrl + "/api/public/onboarding/get?";
        if (body === null)
            throw new Error("The parameter 'body' cannot be null.");
        else if (body !== undefined)
            url_ += "Body=" + encodeURIComponent("" + body) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingRequestDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OnboardingRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnboardingRequestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingRequestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAdditionalForm(body: string | undefined, tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/public/onboarding/get-additional-form?";
        if (body === null)
            throw new Error("The parameter 'body' cannot be null.");
        else if (body !== undefined)
            url_ += "Body=" + encodeURIComponent("" + body) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdditionalForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdditionalForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAdditionalForm(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submit(body: AnonymousTenancyRequestDtoOfSubmitOnboardingRequestInputDto | undefined): Observable<OnboardingRequestDto> {
        let url_ = this.baseUrl + "/api/public/onboarding/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingRequestDto>;
        }));
    }

    protected processSubmit(response: HttpResponseBase): Observable<OnboardingRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnboardingRequestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnboardingRequestDto>(null as any);
    }
}

export interface IPurgeCompanyServiceProxy {
    /**
     * @param id (optional) 
     * @return Success
     */
    purgeCompany(id: number | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class PurgeCompanyServiceProxy implements IPurgeCompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    purgeCompany(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/purge-company?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPurgeCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurgeCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPurgeCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRoleServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_Permissions (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getList(body_Permissions: string[] | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<ListResultDtoOfRoleListDto>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<GetRoleForEditOutput>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: TenancyRequestDtoOfCreateOrUpdateRoleInput | undefined): Observable<void>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RoleServiceProxy implements IRoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/role/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Permissions (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getList(body_Permissions: string[] | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/role/get-list?";
        if (body_Permissions !== undefined && body_Permissions !== null)
            body_Permissions && body_Permissions.forEach(item => { url_ += "Body.Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListResultDtoOfRoleListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    get(body_Id: number | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/role/get?";
        if (body_Id !== undefined && body_Id !== null)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRoleForEditOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: TenancyRequestDtoOfCreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/role/create-or-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    delete(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/role/delete?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ISessionServiceProxy {
    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput>;
    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput>;
}

@Injectable({
    providedIn: 'root'
})
export class SessionServiceProxy implements ISessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/session/get-current-login-informations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCurrentLoginInformationsOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/session/update-user-sign-in-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateUserSignInTokenOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserSignInTokenOutput>(null as any);
    }
}

export interface ITpaAppConfigurationServiceProxy {
    /**
     * @return Success
     */
    getSelfUpdateInformation(): Observable<UpdateInformation>;
    /**
     * @return Success
     */
    triggerSelfUpdateInformation(): Observable<void>;
    /**
     * @return Success
     */
    applicationLanguages(): Observable<GetLanguagesConfigurationDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultApplicationLanguage(body: SetDefaultLanguageInput | undefined): Observable<void>;
    /**
     * @return Success
     */
    hrPortalConfigurationGet(): Observable<HrPortalSettingsDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    hrPortalConfigurationPut(body: HrPortalSettingsInputDto | undefined): Observable<void>;
    /**
     * @return Success
     */
    smsSenderConfigurationGet(): Observable<SmsSenderConfigurationDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    smsSenderConfigurationPut(body: SmsSenderConfigurationDto | undefined): Observable<void>;
    /**
     * @return Success
     */
    smtpConfigurationGet(): Observable<EmailSettingsEditDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    smtpConfigurationPut(body: EmailSettingsEditDto | undefined): Observable<void>;
    /**
     * @return Success
     */
    securityConfigurationGet(): Observable<TpaSecuritySettingsEditDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    securityConfigurationPut(body: TpaSecuritySettingsEditDto | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestSms(body: SendTestSmsInput | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    licenseKeyPut(body: HrPortalLicenseDto | undefined): Observable<void>;
    /**
     * @return Success
     */
    licenseKeyGet(): Observable<HrPortalLicenseDto>;
    /**
     * @return Success
     */
    limits(): Observable<HrPortalLicenseLimitsDto>;
    /**
     * @return Success
     */
    stopApplication(): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    helpUrlPut(body: HrPortalHelpLikUrlDto | undefined): Observable<void>;
    /**
     * @return Success
     */
    helpUrlGet(): Observable<HrPortalHelpLikUrlDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    employeeCardVersionCheck(body: EmployeeCardVersionCheck | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class TpaAppConfigurationServiceProxy implements ITpaAppConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getSelfUpdateInformation(): Observable<UpdateInformation> {
        let url_ = this.baseUrl + "/api/app-configuration/get-self-update-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelfUpdateInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelfUpdateInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateInformation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateInformation>;
        }));
    }

    protected processGetSelfUpdateInformation(response: HttpResponseBase): Observable<UpdateInformation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateInformation;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateInformation>(null as any);
    }

    /**
     * @return Success
     */
    triggerSelfUpdateInformation(): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/trigger-self-update-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerSelfUpdateInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerSelfUpdateInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTriggerSelfUpdateInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    applicationLanguages(): Observable<GetLanguagesConfigurationDto> {
        let url_ = this.baseUrl + "/api/app-configuration/application-languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesConfigurationDto>;
        }));
    }

    protected processApplicationLanguages(response: HttpResponseBase): Observable<GetLanguagesConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLanguagesConfigurationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguagesConfigurationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultApplicationLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/set-default-application-language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultApplicationLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultApplicationLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultApplicationLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    hrPortalConfigurationGet(): Observable<HrPortalSettingsDto> {
        let url_ = this.baseUrl + "/api/app-configuration/hr-portal-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHrPortalConfigurationGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHrPortalConfigurationGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HrPortalSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HrPortalSettingsDto>;
        }));
    }

    protected processHrPortalConfigurationGet(response: HttpResponseBase): Observable<HrPortalSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HrPortalSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HrPortalSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    hrPortalConfigurationPut(body: HrPortalSettingsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/hr-portal-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHrPortalConfigurationPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHrPortalConfigurationPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHrPortalConfigurationPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    smsSenderConfigurationGet(): Observable<SmsSenderConfigurationDto> {
        let url_ = this.baseUrl + "/api/app-configuration/sms-sender-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmsSenderConfigurationGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmsSenderConfigurationGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmsSenderConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmsSenderConfigurationDto>;
        }));
    }

    protected processSmsSenderConfigurationGet(response: HttpResponseBase): Observable<SmsSenderConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SmsSenderConfigurationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SmsSenderConfigurationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    smsSenderConfigurationPut(body: SmsSenderConfigurationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/sms-sender-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmsSenderConfigurationPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmsSenderConfigurationPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSmsSenderConfigurationPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    smtpConfigurationGet(): Observable<EmailSettingsEditDto> {
        let url_ = this.baseUrl + "/api/app-configuration/smtp-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmtpConfigurationGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmtpConfigurationGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSettingsEditDto>;
        }));
    }

    protected processSmtpConfigurationGet(response: HttpResponseBase): Observable<EmailSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSettingsEditDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    smtpConfigurationPut(body: EmailSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/smtp-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmtpConfigurationPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmtpConfigurationPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSmtpConfigurationPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    securityConfigurationGet(): Observable<TpaSecuritySettingsEditDto> {
        let url_ = this.baseUrl + "/api/app-configuration/security-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecurityConfigurationGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurityConfigurationGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TpaSecuritySettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TpaSecuritySettingsEditDto>;
        }));
    }

    protected processSecurityConfigurationGet(response: HttpResponseBase): Observable<TpaSecuritySettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TpaSecuritySettingsEditDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TpaSecuritySettingsEditDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    securityConfigurationPut(body: TpaSecuritySettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/security-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecurityConfigurationPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurityConfigurationPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSecurityConfigurationPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/send-test-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestSms(body: SendTestSmsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/send-test-sms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    licenseKeyPut(body: HrPortalLicenseDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/license-key";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLicenseKeyPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLicenseKeyPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLicenseKeyPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    licenseKeyGet(): Observable<HrPortalLicenseDto> {
        let url_ = this.baseUrl + "/api/app-configuration/license-key";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLicenseKeyGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLicenseKeyGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HrPortalLicenseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HrPortalLicenseDto>;
        }));
    }

    protected processLicenseKeyGet(response: HttpResponseBase): Observable<HrPortalLicenseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HrPortalLicenseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HrPortalLicenseDto>(null as any);
    }

    /**
     * @return Success
     */
    limits(): Observable<HrPortalLicenseLimitsDto> {
        let url_ = this.baseUrl + "/api/app-configuration/license/limits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLimits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLimits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HrPortalLicenseLimitsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HrPortalLicenseLimitsDto>;
        }));
    }

    protected processLimits(response: HttpResponseBase): Observable<HrPortalLicenseLimitsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HrPortalLicenseLimitsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HrPortalLicenseLimitsDto>(null as any);
    }

    /**
     * @return Success
     */
    stopApplication(): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/stop-application";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStopApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    helpUrlPut(body: HrPortalHelpLikUrlDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/help-url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHelpUrlPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHelpUrlPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHelpUrlPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    helpUrlGet(): Observable<HrPortalHelpLikUrlDto> {
        let url_ = this.baseUrl + "/api/app-configuration/help-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHelpUrlGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHelpUrlGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HrPortalHelpLikUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HrPortalHelpLikUrlDto>;
        }));
    }

    protected processHelpUrlGet(response: HttpResponseBase): Observable<HrPortalHelpLikUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HrPortalHelpLikUrlDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HrPortalHelpLikUrlDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    employeeCardVersionCheck(body: EmployeeCardVersionCheck | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/app-configuration/employee-card-version-check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployeeCardVersionCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployeeCardVersionCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmployeeCardVersionCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ITpaLocalizationServiceProxy {
    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | null | undefined): Observable<GetLanguageForEditOutput>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void>;
    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void>;
    /**
     * @return Success
     */
    getXlsx(): Observable<FileDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    importXlsx(body: UploadTranslationInputDto | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class TpaLocalizationServiceProxy implements ITpaLocalizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/localization-management/get-languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLanguagesOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguagesOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | null | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/localization-management/get-language-for-edit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLanguageForEditOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguageForEditOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/localization-management/create-or-update-language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/localization-management/set-default-language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/localization-management/delete-language?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getXlsx(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/localization-management/get-xlsx";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetXlsx(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetXlsx(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetXlsx(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importXlsx(body: UploadTranslationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/localization-management/import-xlsx";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportXlsx(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportXlsx(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportXlsx(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ITpaTemplateMailingServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestMailingTemplates(body: SendTestEmailRequest | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class TpaTemplateMailingServiceProxy implements ITpaTemplateMailingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestMailingTemplates(body: SendTestEmailRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/template-mailing/send-test-mailing-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestMailingTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestMailingTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestMailingTemplates(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IUserServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    accounts(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserAccountDto>;
    /**
     * @param id (optional) 
     * @return Success
     */
    companyAccounts(id: number | undefined): Observable<UserCompaniesListDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    password(body: ManageUserPasswrodInputDto | undefined): Observable<void>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    rolesGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserRoleDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resendActivationEmail(body: TenancyRequestDtoOfEntityDtoOfInt64 | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    rolesPut(body: TenancyRequestDtoOfAssignUserToRolesInput | undefined): Observable<void>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    twoFactorAuthenticationGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<ManageTwoFactorAuthDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    twoFactorAuthenticationPut(body: TenancyRequestDtoOfManageTwoFactorAuthDto | undefined): Observable<ManageTwoFactorAuthDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    employee(body: TenancyRequestDtoOfCreateEmployeeUserInputDto | undefined): Observable<number>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    activeStatusGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserActiveDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    activeStatusPut(body: TenancyRequestDtoOfUserActiveDto | undefined): Observable<UserActiveDto>;
}

@Injectable({
    providedIn: 'root'
})
export class UserServiceProxy implements IUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    accounts(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserAccountDto> {
        let url_ = this.baseUrl + "/api/user/get/accounts?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccountDto>;
        }));
    }

    protected processAccounts(response: HttpResponseBase): Observable<UserAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAccountDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAccountDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    companyAccounts(id: number | undefined): Observable<UserCompaniesListDto[]> {
        let url_ = this.baseUrl + "/api/user/get/company-accounts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCompaniesListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCompaniesListDto[]>;
        }));
    }

    protected processCompanyAccounts(response: HttpResponseBase): Observable<UserCompaniesListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserCompaniesListDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCompaniesListDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    password(body: ManageUserPasswrodInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user/update/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    rolesGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserRoleDto[]> {
        let url_ = this.baseUrl + "/api/user/get/roles?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolesGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolesGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleDto[]>;
        }));
    }

    protected processRolesGet(response: HttpResponseBase): Observable<UserRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRoleDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendActivationEmail(body: TenancyRequestDtoOfEntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user/resend-activation-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendActivationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendActivationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendActivationEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rolesPut(body: TenancyRequestDtoOfAssignUserToRolesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user/update/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolesPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolesPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRolesPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    twoFactorAuthenticationGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<ManageTwoFactorAuthDto> {
        let url_ = this.baseUrl + "/api/user/get/two-factor-authentication?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwoFactorAuthenticationGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwoFactorAuthenticationGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManageTwoFactorAuthDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManageTwoFactorAuthDto>;
        }));
    }

    protected processTwoFactorAuthenticationGet(response: HttpResponseBase): Observable<ManageTwoFactorAuthDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManageTwoFactorAuthDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManageTwoFactorAuthDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    twoFactorAuthenticationPut(body: TenancyRequestDtoOfManageTwoFactorAuthDto | undefined): Observable<ManageTwoFactorAuthDto> {
        let url_ = this.baseUrl + "/api/user/update/two-factor-authentication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTwoFactorAuthenticationPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTwoFactorAuthenticationPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManageTwoFactorAuthDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManageTwoFactorAuthDto>;
        }));
    }

    protected processTwoFactorAuthenticationPut(response: HttpResponseBase): Observable<ManageTwoFactorAuthDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManageTwoFactorAuthDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManageTwoFactorAuthDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    employee(body: TenancyRequestDtoOfCreateEmployeeUserInputDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/user/create/employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processEmployee(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    activeStatusGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserActiveDto> {
        let url_ = this.baseUrl + "/api/user/get/active-status?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveStatusGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveStatusGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActiveDto>;
        }));
    }

    protected processActiveStatusGet(response: HttpResponseBase): Observable<UserActiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserActiveDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserActiveDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activeStatusPut(body: TenancyRequestDtoOfUserActiveDto | undefined): Observable<UserActiveDto> {
        let url_ = this.baseUrl + "/api/user/update/active-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActiveStatusPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveStatusPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserActiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserActiveDto>;
        }));
    }

    protected processActiveStatusPut(response: HttpResponseBase): Observable<UserActiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserActiveDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserActiveDto>(null as any);
    }
}

export interface IUserConfigurationServiceProxy {
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    emailNotificationsSettingsGet(userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmailNotificationConfigurationDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    emailNotificationsSettingsPut(body: TenancyRequestDtoOfEmailNotificationConfigurationDto | undefined): Observable<void>;
    /**
     * @return Success
     */
    userPreferencesGet(): Observable<UserPrefDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    userPreferencesPut(body: UserPrefDto | undefined): Observable<void>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    userCardTemporaryVersionGet(userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserPrefDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    userCardTemporaryVersionPut(body: TenancyRequestDtoOfUserPrefDto | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class UserConfigurationServiceProxy implements IUserConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    emailNotificationsSettingsGet(userId: number | null | undefined, tenantId: number | null | undefined): Observable<EmailNotificationConfigurationDto> {
        let url_ = this.baseUrl + "/api/user-configuration/get/email-notifications-settings?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailNotificationsSettingsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailNotificationsSettingsGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailNotificationConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailNotificationConfigurationDto>;
        }));
    }

    protected processEmailNotificationsSettingsGet(response: HttpResponseBase): Observable<EmailNotificationConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailNotificationConfigurationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailNotificationConfigurationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailNotificationsSettingsPut(body: TenancyRequestDtoOfEmailNotificationConfigurationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user-configuration/update/email-notifications-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailNotificationsSettingsPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailNotificationsSettingsPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmailNotificationsSettingsPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    userPreferencesGet(): Observable<UserPrefDto> {
        let url_ = this.baseUrl + "/api/user-configuration/get/user-preferences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserPreferencesGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserPreferencesGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPrefDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPrefDto>;
        }));
    }

    protected processUserPreferencesGet(response: HttpResponseBase): Observable<UserPrefDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPrefDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPrefDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userPreferencesPut(body: UserPrefDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user-configuration/update/user-preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserPreferencesPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserPreferencesPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserPreferencesPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    userCardTemporaryVersionGet(userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserPrefDto> {
        let url_ = this.baseUrl + "/api/user-configuration/get/user-card-temporary-version?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCardTemporaryVersionGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCardTemporaryVersionGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPrefDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPrefDto>;
        }));
    }

    protected processUserCardTemporaryVersionGet(response: HttpResponseBase): Observable<UserPrefDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPrefDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPrefDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userCardTemporaryVersionPut(body: TenancyRequestDtoOfUserPrefDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user-configuration/update/user-card-temporary-version";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCardTemporaryVersionPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCardTemporaryVersionPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserCardTemporaryVersionPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IUserDepartmentServiceProxy {
    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    usersCanManage(department: string | null, body: DataMangagerTenancyRequest | undefined): Observable<void>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    departmentLookup(userId: number | null | undefined, tenantId: number | null | undefined): Observable<string[]>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    userDepartmentGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<string>;
    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    userCanMangeDepartment(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<string[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    userDepartmentPut(body: TenancyRequestDtoOfUpdateUserDepartmentInput | undefined): Observable<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    canManageDepartment(body: TenancyRequestDtoOfUpdateUserCanManageDepartmentsInput | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class UserDepartmentServiceProxy implements IUserDepartmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    datamanager(body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user-department/datamanager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatamanager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatamanager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatamanager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    usersCanManage(department: string | null, body: DataMangagerTenancyRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user-department/{department}/datamanager/users-can-manage";
        if (department === undefined || department === null)
            throw new Error("The parameter 'department' must be defined.");
        url_ = url_.replace("{department}", encodeURIComponent("" + department));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersCanManage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersCanManage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUsersCanManage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    departmentLookup(userId: number | null | undefined, tenantId: number | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/user-department/get/department-lookup?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDepartmentLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDepartmentLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processDepartmentLookup(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    userDepartmentGet(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/user-department/get/user-department?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDepartmentGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDepartmentGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUserDepartmentGet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body_Id (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    userCanMangeDepartment(body_Id: number | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/user-department/get/user-can-mange-department?";
        if (body_Id === null)
            throw new Error("The parameter 'body_Id' cannot be null.");
        else if (body_Id !== undefined)
            url_ += "Body.Id=" + encodeURIComponent("" + body_Id) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserCanMangeDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserCanMangeDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processUserCanMangeDepartment(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userDepartmentPut(body: TenancyRequestDtoOfUpdateUserDepartmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user-department/update/user-department";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDepartmentPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDepartmentPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserDepartmentPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    canManageDepartment(body: TenancyRequestDtoOfUpdateUserCanManageDepartmentsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user-department/update/can-manage-department";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanManageDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanManageDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCanManageDepartment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IUserCheckerServiceProxy {
    /**
     * @return Success
     */
    check(): Observable<UserCheckListDto>;
    /**
     * @param uuid (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    forceDeleteByUuid(uuid: string | null | undefined, tenantId: number | null | undefined): Observable<void>;
    /**
     * @return Success
     */
    checkAndNormalizeEmail(): Observable<void>;
    /**
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    forceDeleteByUserId(id: number | undefined, tenantId: number | null | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class UserCheckerServiceProxy implements IUserCheckerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    check(): Observable<UserCheckListDto> {
        let url_ = this.baseUrl + "/api/user-checker/check";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCheckListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCheckListDto>;
        }));
    }

    protected processCheck(response: HttpResponseBase): Observable<UserCheckListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserCheckListDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCheckListDto>(null as any);
    }

    /**
     * @param uuid (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    forceDeleteByUuid(uuid: string | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user-checker/force-delete-by-uuid?";
        if (uuid !== undefined && uuid !== null)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceDeleteByUuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceDeleteByUuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForceDeleteByUuid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    checkAndNormalizeEmail(): Observable<void> {
        let url_ = this.baseUrl + "/api/user-checker/check-and-normalize-email";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAndNormalizeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAndNormalizeEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckAndNormalizeEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    forceDeleteByUserId(id: number | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/user-checker/force-delete-by-user-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceDeleteByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceDeleteByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForceDeleteByUserId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IUserTenancyServiceProxy {
    /**
     * @return Success
     */
    tenancies(): Observable<UserTenancyDto[]>;
    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    tenantPermissionsAndFeature(userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserPermissionsAndFeaturesDto>;
}

@Injectable({
    providedIn: 'root'
})
export class UserTenancyServiceProxy implements IUserTenancyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    tenancies(): Observable<UserTenancyDto[]> {
        let url_ = this.baseUrl + "/api/user-tenancy/get/tenancies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenancies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenancies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserTenancyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserTenancyDto[]>;
        }));
    }

    protected processTenancies(response: HttpResponseBase): Observable<UserTenancyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserTenancyDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserTenancyDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    tenantPermissionsAndFeature(userId: number | null | undefined, tenantId: number | null | undefined): Observable<UserPermissionsAndFeaturesDto> {
        let url_ = this.baseUrl + "/api/user-tenancy/get/tenant-permissions-and-feature?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantPermissionsAndFeature(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantPermissionsAndFeature(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissionsAndFeaturesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissionsAndFeaturesDto>;
        }));
    }

    protected processTenantPermissionsAndFeature(response: HttpResponseBase): Observable<UserPermissionsAndFeaturesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPermissionsAndFeaturesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPermissionsAndFeaturesDto>(null as any);
    }
}

export interface IVersionServiceProxy {
    /**
     * @return Success
     */
    version(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class VersionServiceProxy implements IVersionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    version(): Observable<string> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IWebLogServiceProxy {
    /**
     * @return Success
     */
    get(): Observable<GetLatestWebLogsOutput>;
    /**
     * @return Success
     */
    download(): Observable<FileDto>;
}

@Injectable({
    providedIn: 'root'
})
export class WebLogServiceProxy implements IWebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/web-log/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLatestWebLogsOutput;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestWebLogsOutput>(null as any);
    }

    /**
     * @return Success
     */
    download(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/web-log/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

export interface AnnouncementDto {
    titleCz: string;
    titleEn: string;
    textCz: string;
    textEn: string;
    displayFrom: moment.Moment;
    displayTo: moment.Moment;
    severity?: string | undefined;
    id?: string;
}

export interface RequestArchiveInputDto {
    entities?: string[] | undefined;
    files?: string[] | undefined;
    from?: moment.Moment | undefined;
    to?: moment.Moment | undefined;
    tenantId?: number;
}

export interface KeyValuePairOfStringString {
    key?: string | undefined;
    value?: string | undefined;
}

export interface ArchiveArgsDto {
    entities?: KeyValuePairOfStringString[] | undefined;
    files?: KeyValuePairOfStringString[] | undefined;
}

export enum ArtifactTaskState {
    New = 0,
    Completed = 1,
}

export interface TaskListDto {
    creationTime?: moment.Moment;
    taskName?: string | undefined;
    task?: string | undefined;
    artifactType?: string | undefined;
    artifactTypeName?: string | undefined;
    artifactName?: string | undefined;
    artifactId?: number;
    artifactState?: string | undefined;
    taskState?: string | undefined;
    tenantId?: number | undefined;
    department?: string | undefined;
    id?: number;
}

export interface EntityDto {
    id?: number;
}

export interface TenancyRequestDtoOfEntityDto {
    body?: EntityDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface Sort {
    name?: string | undefined;
    direction?: string | undefined;
}

export interface SearchFilter {
    fields?: string[] | undefined;
    key?: string | undefined;
    operator?: string | undefined;
}

export interface WhereFilter {
    field?: string | undefined;
    ignoreCase?: boolean;
    isComplex?: boolean;
    operator?: string | undefined;
    condition?: string | undefined;
    value?: any | undefined;
    predicates?: WhereFilter[] | undefined;
}

export interface Aggregate {
    field?: string | undefined;
    type?: string | undefined;
}

export interface DataMangagerTenancyRequest {
    userId?: number | undefined;
    tenantId?: number | undefined;
    skip?: number;
    take?: number;
    antiForgery?: string | undefined;
    requiresCounts?: boolean;
    table?: string | undefined;
    group?: string[] | undefined;
    select?: string[] | undefined;
    expand?: string[] | undefined;
    sorted?: Sort[] | undefined;
    search?: SearchFilter[] | undefined;
    where?: WhereFilter[] | undefined;
    aggregates?: Aggregate[] | undefined;
}

export interface AuditLogListDto {
    userId?: number | undefined;
    userName?: string | undefined;
    impersonatorTenantId?: number | undefined;
    impersonatorUserId?: number | undefined;
    serviceName?: string | undefined;
    methodName?: string | undefined;
    parameters?: string | undefined;
    executionTime?: moment.Moment;
    executionDuration?: number;
    clientIpAddress?: string | undefined;
    clientName?: string | undefined;
    browserInfo?: string | undefined;
    exception?: string | undefined;
    customData?: string | undefined;
    id?: number;
}

export interface PagedResultDtoOfAuditLogListDto {
    totalCount?: number;
    items?: AuditLogListDto[] | undefined;
}

export interface FileDto {
    fileName: string;
    fileType?: string | undefined;
    fileToken: string;
}

export interface TenancyRequestDto {
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface CacheDto {
    name?: string | undefined;
}

export interface ListResultDtoOfCacheDto {
    items?: CacheDto[] | undefined;
}

export interface EntityDtoOfString {
    id?: string | undefined;
}

export interface DataManagerRequest {
    skip?: number;
    take?: number;
    antiForgery?: string | undefined;
    requiresCounts?: boolean;
    table?: string | undefined;
    group?: string[] | undefined;
    select?: string[] | undefined;
    expand?: string[] | undefined;
    sorted?: Sort[] | undefined;
    search?: SearchFilter[] | undefined;
    where?: WhereFilter[] | undefined;
    aggregates?: Aggregate[] | undefined;
}

export interface CompanyDto {
    name?: string | undefined;
    tenancyName?: string | undefined;
    ico?: string | undefined;
    dps?: moment.Moment | undefined;
    creationTime?: moment.Moment;
    isActive?: boolean;
    is2faRequired?: boolean;
    placeOfResidence?: string | undefined;
    street?: string | undefined;
    descriptiveNumber?: string | undefined;
    orientationNumber?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
    id?: number;
}

export interface NameValueDto {
    name?: string | undefined;
    value?: string | undefined;
}

export interface IValueValidator {
    readonly name?: string | undefined;
    readonly attributes?: { [key: string]: any; } | undefined;
}

export interface LocalizableComboboxItemDto {
    value?: string | undefined;
    displayText?: string | undefined;
}

export interface LocalizableComboboxItemSourceDto {
    items?: LocalizableComboboxItemDto[] | undefined;
}

export interface FeatureInputTypeDto {
    name?: string | undefined;
    attributes?: { [key: string]: any; } | undefined;
    validator?: IValueValidator;
    itemSource?: LocalizableComboboxItemSourceDto;
}

export interface FlatFeatureDto {
    parentName?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    defaultValue?: string | undefined;
    inputType?: FeatureInputTypeDto;
}

export interface GetTenantFeaturesEditOutput {
    featureValues?: NameValueDto[] | undefined;
    features?: FlatFeatureDto[] | undefined;
}

export interface EmployeeCardPaymentOptions {
    bankcr?: boolean;
    bankabroad?: boolean;
    cash?: boolean;
}

export interface CompanyEmployeeCardOptionsDto {
    employeeCardPaymentOptions?: EmployeeCardPaymentOptions;
}

export interface UpdateTenantFeaturesInput {
    id?: number;
    featureValues: NameValueDto[];
}

export interface CreateCompanyInput {
    tenancyName: string;
    name: string;
    isActive?: boolean;
    ico: string;
}

export interface UpdateCompanyInput {
    name?: string | undefined;
    ico?: string | undefined;
    dps?: moment.Moment | undefined;
    isActive?: boolean;
    is2faRequired?: boolean;
    id?: number;
}

export interface DocumentTagOrganizationUnitTranslationDto {
    displayName: string;
    language: string;
}

export enum DocumentTagValidity {
    None = 0,
    EndOfTheYear = 1,
}

export interface DocumentTagDto {
    tagId?: string | undefined;
    displayName?: string | undefined;
    validity?: DocumentTagValidity;
    id?: string | undefined;
}

export interface DocumentTagOrganizationUnitRoleDto {
    name?: string | undefined;
    displayName?: string | undefined;
}

export interface DocumentTagOrganizationUnitDto {
    code?: string | undefined;
    displayName?: string | undefined;
    translations?: DocumentTagOrganizationUnitTranslationDto[] | undefined;
    tags?: DocumentTagDto[] | undefined;
    roles?: DocumentTagOrganizationUnitRoleDto[] | undefined;
    id?: number;
}

export interface CreateDocumentTagOrganizationUnitDto {
    parentId?: number | undefined;
    tagIds?: string[] | undefined;
    roleNames?: string[] | undefined;
    translations?: DocumentTagOrganizationUnitTranslationDto[] | undefined;
}

export interface TenancyRequestDtoOfCreateDocumentTagOrganizationUnitDto {
    body?: CreateDocumentTagOrganizationUnitDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UpdateDocumentTagOrganizationUnitDto {
    tagIds?: string[] | undefined;
    roleNames?: string[] | undefined;
    translations?: DocumentTagOrganizationUnitTranslationDto[] | undefined;
}

export interface TenancyRequestDtoOfUpdateDocumentTagOrganizationUnitDto {
    body?: UpdateDocumentTagOrganizationUnitDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface MoveDocumentTagOrganizationUnitDto {
    parentId?: number | undefined;
}

export interface TenancyRequestDtoOfMoveDocumentTagOrganizationUnitDto {
    body?: MoveDocumentTagOrganizationUnitDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface AttachmentDto {
    id?: string | undefined;
    directUrlDownloadLink?: string | undefined;
    pdfService?: string | undefined;
    fileName: string;
    fileType?: string | undefined;
    fileToken: string;
}

export interface UploadArtifactAttachment {
    artifactType: string;
    attachments?: FileDto[] | undefined;
    id?: number;
}

export interface TenancyRequestDtoOfUploadArtifactAttachment {
    body?: UploadArtifactAttachment;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface MessageDto {
    message?: string | undefined;
    creationTime?: moment.Moment;
    authorName?: string | undefined;
    creatorUserId?: number | undefined;
    id?: number;
}

export interface AppendMessagesInputDto {
    message?: string | undefined;
    artifactType: string;
    id?: number;
}

export interface TenancyRequestDtoOfAppendMessagesInputDto {
    body?: AppendMessagesInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface DocumentDto {
    tag?: DocumentTagDto;
    accessGranted?: boolean;
    name?: string | undefined;
    tagId?: string | undefined;
    ownerId?: number | undefined;
    owner?: string | undefined;
    ownerName?: string | undefined;
    ownerSurname?: string | undefined;
    attachment?: AttachmentDto;
    state?: number;
    validTo?: moment.Moment | undefined;
    notifyAt?: moment.Moment | undefined;
    deletionTime?: moment.Moment | undefined;
    isDeleted?: boolean;
    firstViewByOwner?: moment.Moment | undefined;
    acceptanceByOwner?: moment.Moment | undefined;
    confirmationOfAcceptanceRequired?: boolean;
    forConfirmation?: boolean;
    department?: string | undefined;
    creationTime?: moment.Moment;
    creatorUserId?: number | undefined;
    lastModificationTime?: moment.Moment | undefined;
    lastModifierUserId?: number | undefined;
    id?: number;
}

export interface EmployeeUploadDocument {
    tagId?: string | undefined;
    forYear?: number;
    attachment: FileDto;
}

export interface TenancyRequestDtoOfEmployeeUploadDocument {
    body?: EmployeeUploadDocument;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export enum EmployeeCardState {
    OK = 0,
    ToProcess = 1,
    ToCheck = 2,
}

export interface EmployeeCardData {
    /** Polymorphic discriminator */
    version?: string;
}

export interface EmployeeCardHistoryDto {
    data: EmployeeCardData;
}

export interface EmployeeCardDto {
    linkId?: number;
    warning?: boolean;
    cardState?: EmployeeCardState;
    current?: EmployeeCardHistoryDto;
    lastApproved?: EmployeeCardHistoryDto;
    lastSignature?: moment.Moment | undefined;
    hasSignedCard?: boolean;
    extensionEmployeeCardForm?: any | undefined;
    id?: number;
}

export interface EmployeeCardSummaryDto {
    linkId?: number;
    current?: EmployeeCardHistoryDto;
    id?: number;
}

export interface TenancyRequestDtoOfEmployeeCardHistoryDto {
    body?: EmployeeCardHistoryDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface CompanyAddressDto {
    placeOfResidence?: string | undefined;
    street?: string | undefined;
    descriptiveNumber?: string | undefined;
    orientationNumber?: string | undefined;
    postalCode?: string | undefined;
    country?: string | undefined;
}

export interface EmployeeCardMetadataDto {
    accountantName?: string | undefined;
    accountSignDate?: string | undefined;
    signedAt?: string | undefined;
    tenantName?: string | undefined;
    companyAddress?: CompanyAddressDto;
    id?: number;
}

export interface CreateGeneralArtifactInputDto {
    title?: string | undefined;
    message?: string | undefined;
    category?: string | undefined;
    attachments?: FileDto[] | undefined;
}

export interface TenancyRequestDtoOfCreateGeneralArtifactInputDto {
    body?: CreateGeneralArtifactInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export enum GeneralArtifactState {
    Open = 0,
    Closed = 1,
}

export interface GeneralArtifactDto {
    message?: string | undefined;
    numState?: number;
    state?: GeneralArtifactState;
    owner?: string | undefined;
    ownerName?: string | undefined;
    ownerSurname?: string | undefined;
    category?: string | undefined;
    department?: string | undefined;
    name?: string | undefined;
    artifactType?: string | undefined;
    artifactTypeName?: string | undefined;
    creationTime?: moment.Moment;
    lastModificationTime?: moment.Moment | undefined;
    ownerId?: number | undefined;
    id?: number;
}

export interface AddressHint {
    ulice?: string | undefined;
    popCislo?: string | undefined;
    orCislo?: string | undefined;
    mesto?: string | undefined;
    psc?: string | undefined;
    zeme?: string | undefined;
}

export interface ChildHint {
    jmeno?: string | undefined;
    prijmeni?: string | undefined;
    rodneCislo?: string | undefined;
    datumNarozeni?: string | undefined;
}

export interface PersonHint {
    jmeno?: string | undefined;
    prijmeni?: string | undefined;
    rodneCislo?: string | undefined;
    datumNarozeni?: string | undefined;
}

export interface EmployeeHints {
    addresses?: AddressHint[] | undefined;
    children?: ChildHint[] | undefined;
    otherPersons?: PersonHint[] | undefined;
}

export enum Obligation {
    MainForIndefiniteTimePeriod = 0,
    MainForDefiniteTimePeriod = 1,
    AdditionalForIndefiniteTimePeriod = 2,
    AdditionalForDefiniteTimePeriod = 3,
    ParallelForIndefiniteTimePeriod = 4,
    ParallelForDefiniteTimePeriod = 5,
    CoOperativeMembership = 6,
    CasualEmployment = 7,
    Trainees = 8,
    PartTimeWorkContract = 9,
    AdditionalEmployment = 10,
    CompanyOowner = 11,
    ComplanyStatutoryRepresentative = 12,
    WorkContract = 13,
    LimitedPartner = 14,
}

export interface PayrollDto {
    month?: number;
    year?: number;
    companyName?: string | undefined;
    obligationName?: string | undefined;
    personalNumber?: string | undefined;
    obligation?: Obligation;
    attachment?: AttachmentDto;
    id?: number;
}

export interface EmployeePayrollDto {
    employeeId?: number;
    name?: string | undefined;
    surname?: string | undefined;
    fullName?: string | undefined;
    department?: string | undefined;
    month?: number;
    year?: number;
    companyName?: string | undefined;
    obligationName?: string | undefined;
    personalNumber?: string | undefined;
    obligation?: Obligation;
    attachment?: AttachmentDto;
    id?: number;
}

export interface AnnualTaxSettlement {
    readonly version?: string | undefined;
}

export interface RzdHistoryDto {
    data?: AnnualTaxSettlement;
    id?: number;
}

export enum RzdState {
    Ok = 0,
    ToSign = 1,
    ToProcess = 2,
}

export interface RzdDto {
    requestForRZD?: boolean | undefined;
    requestForconfirmationOfTaxableIncome?: boolean | undefined;
    current?: RzdHistoryDto;
    lastApproved?: RzdHistoryDto;
    lastSigned?: RzdHistoryDto;
    firstVersion?: RzdHistoryDto;
    forYear?: number;
    state?: RzdState;
    lastDateForFirstSign?: moment.Moment;
    lastDateForEdit?: moment.Moment;
    name?: string | undefined;
    artifactType?: string | undefined;
    artifactTypeName?: string | undefined;
    creationTime?: moment.Moment;
    lastModificationTime?: moment.Moment | undefined;
    ownerId?: number | undefined;
    id?: number;
}

export interface SignRzdInputDto {
    requestForRZD?: boolean;
    requestForconfirmationOfTaxableIncome?: boolean;
    data?: AnnualTaxSettlement;
    id?: number;
}

export interface TenancyRequestDtoOfSignRzdInputDto {
    body?: SignRzdInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface TenancyRequestDtoOfRzdHistoryDto {
    body?: RzdHistoryDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface RzdMetadataDto {
    accountantName?: string | undefined;
    accountSignDate?: string | undefined;
    signedAt?: string | undefined;
    tenantName?: string | undefined;
    companyAddress?: CompanyAddressDto;
    id?: number;
}

export interface InsertJournalInputDto {
    heliosId: string;
    action: string;
    data: string;
}

export enum JournalResult {
    New = 0,
    Ok = 200,
    Warning = 300,
    UndefinedOperation = 404,
    Error = 500,
}

export interface UpdateJournalState {
    state?: JournalResult;
}

export interface HtmlToPdfDto {
    html?: string | undefined;
    fileName?: string | undefined;
}

export interface MultipleHtmlToPdfDto {
    data?: HtmlToPdfDto[] | undefined;
}

export interface TenancyRequestDtoOfAnnouncementDto {
    body?: AnnouncementDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface EntityDtoOfGuid {
    id?: string;
}

export interface SendAnnouncementDto {
    titleCz: string;
    titleEn: string;
    textCz: string;
    textEn: string;
}

export interface TenancyRequestDtoOfSendAnnouncementDto {
    body?: SendAnnouncementDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface ApproveDocumentDto {
    tagId?: string | undefined;
    name?: string | undefined;
    validTo?: moment.Moment | undefined;
    notifyAt?: moment.Moment | undefined;
    confirmationOfAcceptanceRequired?: boolean;
    id?: number;
}

export interface TenancyRequestDtoOfApproveDocumentDto {
    body?: ApproveDocumentDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UpdateDocumentTagDto {
    tagId?: string | undefined;
    id?: number;
}

export interface TenancyRequestDtoOfUpdateDocumentTagDto {
    body?: UpdateDocumentTagDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UploadDocument {
    tagId?: string | undefined;
    attachment: FileDto;
    userId: number;
    confirmationOfAcceptanceRequired?: boolean;
}

export interface TenancyRequestDtoOfUploadDocument {
    body?: UploadDocument;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface DocumentTagTranslationDto {
    displayName: string;
    language: string;
}

export interface DocumentTagWithTranslationsDto {
    translations?: DocumentTagTranslationDto[] | undefined;
    tagId?: string | undefined;
    displayName?: string | undefined;
    validity?: DocumentTagValidity;
    id?: string | undefined;
}

export interface DocumentTagInputDto {
    tagId: string;
    validity: DocumentTagValidity;
    translations: DocumentTagTranslationDto[];
}

export interface TenancyRequestDtoOfDocumentTagInputDto {
    body?: DocumentTagInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface ExtendedEmployeeCardDto {
    employeeCard?: EmployeeCardDto;
    helios?: any | undefined;
    note?: string | undefined;
    ownerId?: number | undefined;
    globalNote?: string | undefined;
    name?: string | undefined;
    artifactType?: string | undefined;
    artifactTypeName?: string | undefined;
    creationTime?: moment.Moment;
    lastModificationTime?: moment.Moment | undefined;
    id?: number;
}

export interface EmployeeCardHistoryListDto {
    note?: string | undefined;
    approvedAt?: moment.Moment | undefined;
    approvedBy?: number | undefined;
    approvedByName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    signedAt?: moment.Moment | undefined;
    id?: number;
}

export interface ApproveOrReturnEmployeeCard {
    note?: string | undefined;
    versionId?: number | undefined;
    id?: number;
}

export interface TenancyRequestDtoOfApproveOrReturnEmployeeCard {
    body?: ApproveOrReturnEmployeeCard;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UpdateEmployeeCardNoteInput {
    globalNote?: string | undefined;
    id?: number;
}

export interface TenancyRequestDtoOfUpdateEmployeeCardNoteInput {
    body?: UpdateEmployeeCardNoteInput;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface CreateEmployeeCardDto {
    data?: EmployeeCardData;
    id?: number;
}

export interface TenancyRequestDtoOfCreateEmployeeCardDto {
    body?: CreateEmployeeCardDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface CreateGeneralArtifactForUserInputDto {
    ownerId?: number;
    title?: string | undefined;
    message?: string | undefined;
    category?: string | undefined;
    attachments?: FileDto[] | undefined;
}

export interface TenancyRequestDtoOfCreateGeneralArtifactForUserInputDto {
    body?: CreateGeneralArtifactForUserInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface CreateRzdInput {
    userId?: number;
    forYear?: number;
    lastDateForFirstSign?: moment.Moment | undefined;
}

export interface TenancyRequestDtoOfCreateRzdInput {
    body?: CreateRzdInput;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface RzdHistoryListDto {
    note?: string | undefined;
    approvedAt?: moment.Moment | undefined;
    approvedBy?: number | undefined;
    approvedByName?: string | undefined;
    creationTime?: moment.Moment | undefined;
    signedAt?: moment.Moment | undefined;
    id?: number;
}

export interface RzdOperationInputDto {
    note?: string | undefined;
    versionId?: number | undefined;
    id?: number;
}

export interface TenancyRequestDtoOfRzdOperationInputDto {
    body?: RzdOperationInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface RzdDatesDto {
    lastDateForFirstSign: moment.Moment;
    id?: number;
}

export interface TenancyRequestDtoOfRzdDatesDto {
    body?: RzdDatesDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface OnboardingRequestData {
    jmeno: string;
    prijmeni: string;
    rodnePrijmeni: string;
    rodneCislo?: string | undefined;
    datumNarozeni: string;
    mistoNarozeni: string;
    statniObcanstvi: string;
    predpokladaneDatumNastupu: string;
    additionalParameters?: { [key: string]: string; } | undefined;
}

export enum OnboardingRequestStatus {
    Created = 0,
    Submitted = 1,
    Approved = 2,
    UserCreated = 3,
}

export interface OnboardingRequestExtendedDto {
    emailAddress?: string | undefined;
    data?: OnboardingRequestData;
    linkValidTo?: moment.Moment;
    status?: OnboardingRequestStatus;
    cultureName?: string | undefined;
    id?: string;
}

export interface CreateOnboardingRequestInputDto {
    emailAddress: string;
    linkValidTo: moment.Moment;
    cultureName: string;
}

export interface TenancyRequestDtoOfCreateOnboardingRequestInputDto {
    body?: CreateOnboardingRequestInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface TenancyRequestDtoOfGuid {
    body?: string;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UpdateAdditionalFromInputDto {
    definition?: string | undefined;
}

export interface TenancyRequestDtoOfUpdateAdditionalFromInputDto {
    body?: UpdateAdditionalFromInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface OnboardingRequestNoteDto {
    message?: string | undefined;
    userName?: string | undefined;
    creationTime?: moment.Moment;
    creatorUserId?: number | undefined;
    id?: string;
}

export interface CreateOnboardingRequestNoteInputDto {
    message?: string | undefined;
    id?: string;
}

export interface TenancyRequestDtoOfCreateOnboardingRequestNoteInputDto {
    body?: CreateOnboardingRequestNoteInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface NotificationSubscriptionWithDisplayNameDto {
    displayName?: string | undefined;
    description?: string | undefined;
    name: string;
    isSubscribed?: boolean;
}

export interface GetNotificationSettingsOutput {
    receiveNotifications?: boolean;
    notifications?: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export interface NotificationData {
    readonly type?: string | undefined;
    properties?: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export interface TenantNotification {
    tenantId?: number | undefined;
    notificationName?: string | undefined;
    data?: NotificationData;
    entityType?: string | undefined;
    entityTypeName?: string | undefined;
    entityId?: any | undefined;
    severity?: NotificationSeverity;
    creationTime?: moment.Moment;
    id?: string;
}

export interface UserNotification {
    tenantId?: number | undefined;
    userId?: number;
    state?: UserNotificationState;
    notification?: TenantNotification;
    id?: string;
}

export interface GetNotificationsOutput {
    unreadCount?: number;
    totalCount?: number;
    items?: UserNotification[] | undefined;
}

export interface TenancyRequestDtoOfEntityDtoOfGuid {
    body?: EntityDtoOfGuid;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export enum PayrollRecapStateEnum {
    New = 0,
    Approved = 1,
    Invalidated = 2,
    Denied = 3,
}

export interface PayrollRecapOperationMadeByDto {
    userId?: number | undefined;
    userName?: string | undefined;
    message?: string | undefined;
    performedAt?: moment.Moment;
}

export interface PayrollRecapDto {
    message?: string | undefined;
    currentState?: PayrollRecapStateEnum;
    currentStateName?: string | undefined;
    approved?: PayrollRecapOperationMadeByDto;
    denied?: PayrollRecapOperationMadeByDto;
    invalidated?: PayrollRecapOperationMadeByDto;
    attachments?: AttachmentDto[] | undefined;
    hasUserAuthenticationEnabled?: boolean;
    name?: string | undefined;
    artifactType?: string | undefined;
    artifactTypeName?: string | undefined;
    creationTime?: moment.Moment;
    lastModificationTime?: moment.Moment | undefined;
    ownerId?: number | undefined;
    id?: number;
}

export interface CreatePayrollRecapInputDto {
    title?: string | undefined;
    message?: string | undefined;
    attachments?: FileDto[] | undefined;
}

export interface TenancyRequestDtoOfCreatePayrollRecapInputDto {
    body?: CreatePayrollRecapInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface PayrollRecapOperationInputDto {
    message?: string | undefined;
    code?: string | undefined;
    id?: number;
}

export interface TenancyRequestDtoOfPayrollRecapOperationInputDto {
    body?: PayrollRecapOperationInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface ChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export interface ChangeUserLanguageDto {
    languageName: string;
}

export interface PasswordComplexitySetting {
    requireDigit?: boolean;
    requireLowercase?: boolean;
    requireNonAlphanumeric?: boolean;
    requireUppercase?: boolean;
    requiredLength?: number;
}

export interface GetPasswordComplexitySettingOutput {
    setting?: PasswordComplexitySetting;
}

export interface TpaCurrentUserProfileEditDto {
    phoneNumber?: string | undefined;
    isGoogleAuthenticatorEnabled?: boolean;
    qrCodeSetupImageUrl?: string | undefined;
    manualEntryKey?: string | undefined;
}

export interface RequestSmsVerificationCodeInput {
    phoneNumber?: string | undefined;
}

export interface TwoFactorValidationInput {
    phoneNumber: string;
    twoFactorVerificationCode?: string | undefined;
}

export interface DisableTwoFactorValidationInput {
    provider?: string | undefined;
    twoFactorVerificationCode?: string | undefined;
}

export interface TpaUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl?: string | undefined;
    manualEntryKey?: string | undefined;
}

export interface OnboardingRequestDto {
    linkValidTo?: moment.Moment;
    status?: OnboardingRequestStatus;
    cultureName?: string | undefined;
    id?: string;
}

export interface SubmitOnboardingRequestInputDto {
    id: string;
    data: OnboardingRequestData;
}

export interface AnonymousTenancyRequestDtoOfSubmitOnboardingRequestInputDto {
    body?: SubmitOnboardingRequestInputDto;
    tenantId?: number;
}

export interface RoleListDto {
    name?: string | undefined;
    displayName?: string | undefined;
    isStatic?: boolean;
    isDefault?: boolean;
    creationTime?: moment.Moment;
    id?: number;
}

export interface ListResultDtoOfRoleListDto {
    items?: RoleListDto[] | undefined;
}

export interface RoleEditDto {
    id?: number | undefined;
    displayName: string;
    isDefault?: boolean;
}

export interface FlatPermissionDto {
    parentName?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    isGrantedByDefault?: boolean;
    hasChildren?: boolean;
}

export interface GetRoleForEditOutput {
    role?: RoleEditDto;
    permissions?: FlatPermissionDto[] | undefined;
    grantedPermissionNames?: string[] | undefined;
}

export interface CreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export interface TenancyRequestDtoOfCreateOrUpdateRoleInput {
    body?: CreateOrUpdateRoleInput;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UserLoginInfoDto {
    name?: string | undefined;
    surname?: string | undefined;
    userName?: string | undefined;
    emailAddress?: string | undefined;
    profilePictureId?: string | undefined;
    isTwoFactorEnabled?: string | undefined;
    id?: number;
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export interface EditionInfoDto {
    displayName?: string | undefined;
    trialDayCount?: number | undefined;
    monthlyPrice?: number | undefined;
    annualPrice?: number | undefined;
    isHighestEdition?: boolean;
    isFree?: boolean;
    id?: number;
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export interface TenantLoginInfoDto {
    tenancyName?: string | undefined;
    name?: string | undefined;
    logoId?: string | undefined;
    logoFileType?: string | undefined;
    customCssId?: string | undefined;
    subscriptionEndDateUtc?: moment.Moment | undefined;
    isInTrialPeriod?: boolean;
    subscriptionPaymentType?: SubscriptionPaymentType;
    edition?: EditionInfoDto;
    creationTime?: moment.Moment;
    paymentPeriodType?: PaymentPeriodType;
    subscriptionDateString?: string | undefined;
    creationTimeString?: string | undefined;
    id?: number;
}

export interface ApplicationInfoDto {
    version?: string | undefined;
    releaseDate?: moment.Moment;
    currency?: string | undefined;
    currencySign?: string | undefined;
    allowTenantsToChangeEmailSettings?: boolean;
    userDelegationIsEnabled?: boolean;
    features?: { [key: string]: boolean; } | undefined;
}

export interface ThemeLayoutSettingsDto {
    layoutType?: string | undefined;
}

export interface ThemeHeaderSettingsDto {
    desktopFixedHeader?: boolean;
    mobileFixedHeader?: boolean;
    headerSkin?: string | undefined;
    minimizeDesktopHeaderType?: string | undefined;
    headerMenuArrows?: boolean;
}

export interface ThemeSubHeaderSettingsDto {
    fixedSubHeader?: boolean;
    subheaderStyle?: string | undefined;
}

export interface ThemeMenuSettingsDto {
    position?: string | undefined;
    asideSkin?: string | undefined;
    fixedAside?: boolean;
    allowAsideMinimizing?: boolean;
    defaultMinimizedAside?: boolean;
    submenuToggle?: string | undefined;
    searchActive?: boolean;
}

export interface ThemeFooterSettingsDto {
    fixedFooter?: boolean;
}

export interface ThemeSettingsDto {
    theme?: string | undefined;
    layout?: ThemeLayoutSettingsDto;
    header?: ThemeHeaderSettingsDto;
    subHeader?: ThemeSubHeaderSettingsDto;
    menu?: ThemeMenuSettingsDto;
    footer?: ThemeFooterSettingsDto;
}

export interface UiCustomizationSettingsDto {
    baseSettings?: ThemeSettingsDto;
    isLeftMenuUsed?: boolean;
    isTopMenuUsed?: boolean;
    isTabMenuUsed?: boolean;
    allowMenuScroll?: boolean;
}

export interface GetCurrentLoginInformationsOutput {
    user?: UserLoginInfoDto;
    tenant?: TenantLoginInfoDto;
    application?: ApplicationInfoDto;
    theme?: UiCustomizationSettingsDto;
}

export interface UpdateUserSignInTokenOutput {
    signInToken?: string | undefined;
    encodedUserId?: string | undefined;
    encodedTenantId?: string | undefined;
}

export interface UpdateInformation {
    isSameVersion?: boolean;
    availableVersion?: string | undefined;
    isSelfUpdateEnabled?: boolean;
    isUpdatedAvailable?: boolean;
}

export interface LanguageInfo {
    name?: string | undefined;
    displayName?: string | undefined;
    icon?: string | undefined;
    isDefault?: boolean;
    isDisabled?: boolean;
    readonly isRightToLeft?: boolean;
}

export interface GetLanguagesConfigurationDto {
    defaultLanguageName?: string | undefined;
    items?: LanguageInfo[] | undefined;
}

export interface SetDefaultLanguageInput {
    name: string;
}

export interface HrPortalSettingsDto {
    term?: boolean;
    emailSignature?: string | undefined;
    intercom?: string | undefined;
    gtm?: string | undefined;
    authenticatorIssuer?: string | undefined;
    applicationName?: string | undefined;
    companyName?: string | undefined;
}

export interface HrPortalSettingsInputDto {
    term?: boolean;
    intercom?: string | undefined;
    emailSignature?: string | undefined;
    gtm?: string | undefined;
    authenticatorIssuer?: string | undefined;
    applicationName?: string | undefined;
    companyName?: string | undefined;
}

export interface TwilioConfigurationDto {
    accountSid?: string | undefined;
    authToken?: string | undefined;
    senderNumber?: string | undefined;
    senderId?: string | undefined;
}

export interface SmsSluzbaConfigurationDto {
    login?: string | undefined;
    password?: string | undefined;
}

export interface SmsSenderConfigurationDto {
    sender?: string | undefined;
    twilio?: TwilioConfigurationDto;
    smsSluzba?: SmsSluzbaConfigurationDto;
}

export interface EmailSettingsEditDto {
    defaultFromAddress?: string | undefined;
    defaultFromDisplayName?: string | undefined;
    smtpHost?: string | undefined;
    smtpPort?: number;
    smtpUserName?: string | undefined;
    smtpPassword?: string | undefined;
    smtpDomain?: string | undefined;
    smtpEnableSsl?: boolean;
    smtpUseDefaultCredentials?: boolean;
}

export interface TpaTwoFactorLoginSettingsEditDto {
    isEnabled?: boolean;
}

export interface UserLockOutSettingsEditDto {
    isEnabled?: boolean;
    maxFailedAccessAttemptsBeforeLockout?: number;
    defaultAccountLockoutSeconds?: number;
}

export interface TpaSecuritySettingsEditDto {
    twoFactorLogin?: TpaTwoFactorLoginSettingsEditDto;
    allowOneConcurrentLoginPerUser?: boolean;
    passwordComplexity?: PasswordComplexitySetting;
    userLockOut?: UserLockOutSettingsEditDto;
}

export interface SendTestEmailInput {
    emailAddress: string;
}

export interface SendTestSmsInput {
    phoneNumber: string;
}

export interface HrPortalLicenseDto {
    key?: string | undefined;
}

export interface HrPortalLicenseLimitsDto {
    maxUserLimitReached?: boolean;
    maxUserCount?: number | undefined;
    currentUserCount?: number;
}

export interface HrPortalHelpLikUrlDto {
    url?: string | undefined;
}

export interface EmployeeCardVersionCheck {
    date?: moment.Moment;
}

export interface ApplicationLanguageListDto {
    tenantId?: number | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    icon?: string | undefined;
    isDisabled?: boolean;
    isDeleted?: boolean;
    deleterUserId?: number | undefined;
    deletionTime?: moment.Moment | undefined;
    lastModificationTime?: moment.Moment | undefined;
    lastModifierUserId?: number | undefined;
    creationTime?: moment.Moment;
    creatorUserId?: number | undefined;
    id?: number;
}

export interface GetLanguagesOutput {
    defaultLanguageName?: string | undefined;
    items?: ApplicationLanguageListDto[] | undefined;
}

export interface ApplicationLanguageEditDto {
    id?: number | undefined;
    name: string;
    displayName: string;
    icon?: string | undefined;
    isEnabled?: boolean;
}

export interface ComboboxItemDto {
    value?: string | undefined;
    displayText?: string | undefined;
    isSelected?: boolean;
}

export interface GetLanguageForEditOutput {
    language?: ApplicationLanguageEditDto;
    languageNames?: ComboboxItemDto[] | undefined;
    flags?: ComboboxItemDto[] | undefined;
}

export interface CreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export interface UploadTranslationInputDto {
    attachment: FileDto;
}

export interface SendTestEmailRequest {
    sentTo?: string | undefined;
}

export interface UserAccountDto {
    name?: string | undefined;
    surname?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isEmailConfirmed?: boolean;
    dps?: moment.Moment | undefined;
    isActive?: boolean;
    uuid?: string | undefined;
    id?: number;
}

export interface UserCompaniesListDto {
    tenantId?: number | undefined;
    tenantName?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    isActive?: boolean;
    id?: number;
}

export interface ManageUserPasswrodInputDto {
    password?: string | undefined;
    setRandomPassword?: boolean;
    shouldChangePasswordOnNextLogin?: boolean;
    id?: number;
}

export interface UserRoleDto {
    roleId?: number;
    roleName?: string | undefined;
    roleDisplayName?: string | undefined;
    isAssigned?: boolean;
    inheritedFromOrganizationUnit?: boolean;
}

export interface EntityDtoOfInt64 {
    id?: number;
}

export interface TenancyRequestDtoOfEntityDtoOfInt64 {
    body?: EntityDtoOfInt64;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface AssignUserToRolesInput {
    assignedRoleNames?: string[] | undefined;
    id?: number;
}

export interface TenancyRequestDtoOfAssignUserToRolesInput {
    body?: AssignUserToRolesInput;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface ManageTwoFactorAuthDto {
    isTwoFactorEnabled?: boolean;
    phoneNumber?: string | undefined;
    id?: number;
}

export interface TenancyRequestDtoOfManageTwoFactorAuthDto {
    body?: ManageTwoFactorAuthDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface CreateEmployeeUserInputDto {
    name?: string | undefined;
    surname?: string | undefined;
    emailAdress?: string | undefined;
    rc?: string | undefined;
    countryCode?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    languageName?: string | undefined;
    createEmplyoeeCard?: boolean;
    kartaZamestnanceHe?: EmployeeCardData;
}

export interface TenancyRequestDtoOfCreateEmployeeUserInputDto {
    body?: CreateEmployeeUserInputDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UserActiveDto {
    isActive?: boolean;
    id?: number;
}

export interface TenancyRequestDtoOfUserActiveDto {
    body?: UserActiveDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface EmailNotificationConfigurationDto {
    isEnabled?: boolean;
}

export interface TenancyRequestDtoOfEmailNotificationConfigurationDto {
    body?: EmailNotificationConfigurationDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UserPrefDto {
    data?: string | undefined;
}

export interface TenancyRequestDtoOfUserPrefDto {
    body?: UserPrefDto;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UpdateUserDepartmentInput {
    id?: number;
    department?: string | undefined;
}

export interface TenancyRequestDtoOfUpdateUserDepartmentInput {
    body?: UpdateUserDepartmentInput;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UpdateUserCanManageDepartmentsInput {
    id?: number;
    departments?: string[] | undefined;
}

export interface TenancyRequestDtoOfUpdateUserCanManageDepartmentsInput {
    body?: UpdateUserCanManageDepartmentsInput;
    userId?: number | undefined;
    tenantId?: number | undefined;
}

export interface UserCheckDto {
    userId?: number | undefined;
    tenantId?: number | undefined;
    uuid?: string | undefined;
}

export interface UserCheckListDto {
    countOfUsers?: number;
    countOfHeliosUsers?: number;
    readonly isCountSame?: boolean;
    problems?: UserCheckDto[] | undefined;
    uniqueUuids?: string[] | undefined;
}

export interface UserTenancyDto {
    canAccess2FAIsEnabled?: boolean;
    countOfDepartments?: number;
    heliosId?: string | undefined;
    tenantId?: number | undefined;
    tenancyName?: string | undefined;
    username?: string | undefined;
    id?: number;
}

export interface UserPermissionsAndFeaturesDto {
    features?: NameValueDto[] | undefined;
    allPermissions?: NameValueDto[] | undefined;
    grantedPermissions?: NameValueDto[] | undefined;
    hasEmployeeCard?: number | undefined;
    hasSignedEmployeeCard?: boolean | undefined;
}

export interface GetLatestWebLogsOutput {
    latestWebLogLines?: string[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}